(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[45828],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 70988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewJerseyDisclaimer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89588);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function NewJerseyDisclaimer({ backGround , textColor  }) {
    const outerSectionStyle = {
        "--bg": `${backGround ?? "gray"}`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().mainContainer),
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            style: {
                color: textColor ?? " black"
            },
            className: "lg:text-sm text-xs lg:leading-6 font-light text-center py-2 max-w-[900px] mx-auto",
            children: "New Jersey residents: The product being offered is a service contract and is separate and distinct from any product or service warranty which may be provided by the home builder or manufacturer."
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 45016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/benefits/icons/saveMoney.tsx


function SaveMoney() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "81",
        height: "80",
        fill: "none",
        viewBox: "0 0 81 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#6F92B8",
                d: "M77.513 50.67H66.179a37.495 37.495 0 00-13.956-21.122 3.977 3.977 0 001.178-3.547 3.974 3.974 0 00-2.292-2.957l3.475-12.24a5.313 5.313 0 00-.865-4.671 5.336 5.336 0 00-4.259-2.125h-2.417a8.008 8.008 0 00-2.936-2.934 8.033 8.033 0 00-10.963 2.934h-2.419a5.348 5.348 0 00-4.254 2.123 5.319 5.319 0 00-.867 4.666l3.475 12.247a3.986 3.986 0 00-2.292 2.958 3.97 3.97 0 001.181 3.549A37.791 37.791 0 0014.007 50.67H4.01a3.998 3.998 0 00-3.667 2.366 3.973 3.973 0 00.7 4.3 3.933 3.933 0 000 5.333 3.958 3.958 0 00-.405 4.83c.317.488.738.9 1.233 1.208a3.859 3.859 0 000 3.922 3.982 3.982 0 00-.271 6.573c.695.52 1.54.8 2.41.798h21.382a4.006 4.006 0 003.556-2.192A29.517 29.517 0 0040.093 80h37.42c.709 0 1.388-.28 1.89-.781.501-.5.783-1.178.783-1.885V53.336c0-.707-.282-1.385-.783-1.885a2.676 2.676 0 00-1.89-.781zm0 6.477a5.337 5.337 0 01-2.43-1.388 5.318 5.318 0 01-1.39-2.423h3.82v3.81zM30.739 28.006a1.338 1.338 0 01-1.337-1.333 1.332 1.332 0 011.337-1.334h18.71a1.338 1.338 0 011.336 1.334 1.332 1.332 0 01-1.337 1.333h-18.71zm-2.13-20.273a2.629 2.629 0 012.115-1.058h1.47a8.03 8.03 0 00-.119 1.333v5.333a1.332 1.332 0 001.336 1.333 1.338 1.338 0 001.337-1.333V8.008a5.27 5.27 0 01.444-2.133 5.336 5.336 0 011.97-2.33 5.355 5.355 0 017.83 2.33c.297.672.449 1.399.447 2.133v5.333a1.332 1.332 0 001.337 1.333 1.338 1.338 0 001.336-1.333V8.008a8.031 8.031 0 00-.12-1.333h1.47a2.678 2.678 0 012.118 1.068 2.664 2.664 0 01.431 2.329l-3.573 12.601h-16.69l-3.574-12.608a2.63 2.63 0 01.434-2.332zM4.01 53.336h21.383a1.338 1.338 0 011.336 1.334 1.332 1.332 0 01-1.336 1.333H4.01a1.338 1.338 0 01-1.336-1.334 1.331 1.331 0 011.337-1.333zm0 17.332a1.331 1.331 0 011.337-1.334h21.382a1.338 1.338 0 011.337 1.334A1.332 1.332 0 0126.729 72H5.347a1.338 1.338 0 01-1.337-1.333zm0-4a1.338 1.338 0 01-1.336-1.333 1.331 1.331 0 011.337-1.333h21.382a1.338 1.338 0 011.336 1.333 1.332 1.332 0 01-1.336 1.333H4.01zm-1.336-6.666a1.331 1.331 0 011.337-1.333h21.382a1.338 1.338 0 011.336 1.333 1.332 1.332 0 01-1.336 1.333H4.01a1.338 1.338 0 01-1.336-1.333zm22.719 17.332H4.01A1.338 1.338 0 012.675 76a1.332 1.332 0 011.337-1.333h21.382A1.338 1.338 0 0126.729 76a1.332 1.332 0 01-1.336 1.334zm3.876-2.299a3.995 3.995 0 00-.401-.996 3.98 3.98 0 001.872-3.371 3.97 3.97 0 00-1.872-3.372 3.9 3.9 0 00-.508-4.627 3.933 3.933 0 000-5.333 3.978 3.978 0 00-.78-6.027 3.999 3.999 0 00-2.187-.64h-8.65c1.975-7.849 7.912-16.167 14.377-19.997h17.946c8.203 4.85 15.083 16.358 15.083 25.33 0 11.762-10.792 21.332-24.056 21.332a26.765 26.765 0 01-10.824-2.299zm37.553-19.032a22.472 22.472 0 00-.184-2.667h4.313a8.003 8.003 0 002.237 4.315 8.035 8.035 0 004.325 2.231v10.906a8.035 8.035 0 00-4.325 2.231 8.003 8.003 0 00-2.237 4.315H52.283c8.62-3.988 14.538-12.043 14.538-21.331zm6.871 21.33a5.318 5.318 0 011.39-2.422 5.337 5.337 0 012.43-1.388v3.81h-3.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#6F92B8",
                d: "M72.167 69.335a4.016 4.016 0 003.704-2.47 3.99 3.99 0 00-.869-4.358 4.012 4.012 0 00-4.37-.867 3.993 3.993 0 00-1.3 6.523 4.014 4.014 0 002.835 1.172zm0-5.333a1.338 1.338 0 011.235.823 1.33 1.33 0 01-.974 1.818 1.34 1.34 0 01-1.372-.567 1.33 1.33 0 01.166-1.684c.25-.25.59-.39.945-.39zM44.103 48.004a1.332 1.332 0 001.336 1.333 1.338 1.338 0 001.336-1.333 6.668 6.668 0 00-1.508-4.215 6.697 6.697 0 00-3.837-2.318v-.133a1.332 1.332 0 00-1.337-1.334 1.338 1.338 0 00-1.336 1.334v.133a6.685 6.685 0 00-3.844 2.314 6.656 6.656 0 000 8.437 6.685 6.685 0 003.844 2.314v7.889a4.008 4.008 0 01-1.933-1.456 3.992 3.992 0 01-.74-2.3 1.331 1.331 0 00-1.336-1.333 1.338 1.338 0 00-1.337 1.333 6.667 6.667 0 001.509 4.215 6.696 6.696 0 003.837 2.318v.133a1.332 1.332 0 001.336 1.333 1.338 1.338 0 001.337-1.333v-.133a6.685 6.685 0 003.844-2.314 6.656 6.656 0 000-8.437 6.685 6.685 0 00-3.844-2.315V44.25a4.008 4.008 0 011.932 1.455c.479.672.737 1.475.74 2.3zm-8.019 0a3.992 3.992 0 01.74-2.3 4.008 4.008 0 011.933-1.455v7.509a4.008 4.008 0 01-1.932-1.455 3.992 3.992 0 01-.74-2.3zm8.019 10.665a3.993 3.993 0 01-.74 2.3 4.008 4.008 0 01-1.933 1.454v-7.508a4.007 4.007 0 011.932 1.455c.479.672.737 1.475.74 2.3z"
            })
        ]
    });
}
/* harmony default export */ var saveMoney = (SaveMoney);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/benefits/icons/saveTime.tsx


function SaveTime() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "81",
        height: "80",
        fill: "none",
        viewBox: "0 0 81 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#6F92B8",
                d: "M39.386 9.106a1.571 1.571 0 01-1.573-1.575V5.767a1.577 1.577 0 011.573-1.575 1.571 1.571 0 011.573 1.575V7.53a1.577 1.577 0 01-1.573 1.575zM23.671 13.234a1.568 1.568 0 01-1.362-.787l-.88-1.532a1.578 1.578 0 01.623-2.061 1.57 1.57 0 012.094.488l.88 1.532a1.578 1.578 0 01-.575 2.152 1.57 1.57 0 01-.786.21l.006-.002zM12.12 24.68a1.56 1.56 0 01-.785-.211l-1.532-.887a1.574 1.574 0 01-.584-2.157 1.575 1.575 0 012.157-.572l1.53.882a1.574 1.574 0 01.733 1.773 1.574 1.574 0 01-1.52 1.167v.005zM7.832 40.377H6.071a1.571 1.571 0 01-1.573-1.575 1.576 1.576 0 011.573-1.575h1.761a1.571 1.571 0 011.573 1.575 1.576 1.576 0 01-1.573 1.575zM10.425 57.003a1.571 1.571 0 01-1.521-1.166 1.578 1.578 0 01.733-1.774l1.529-.882a1.571 1.571 0 012.355 1.156 1.575 1.575 0 01-.783 1.573l-1.528.882a1.56 1.56 0 01-.785.211zM22.495 69.22a1.569 1.569 0 01-1.362-.788 1.577 1.577 0 01.002-1.575l.88-1.533A1.573 1.573 0 0124.74 66.9l-.88 1.533a1.575 1.575 0 01-1.364.787zM39.05 73.752a1.572 1.572 0 01-1.572-1.575v-1.764a1.577 1.577 0 011.572-1.575 1.571 1.571 0 011.573 1.575v1.764a1.575 1.575 0 01-1.573 1.575zM72.372 40.72h-1.761a1.571 1.571 0 01-1.573-1.575 1.577 1.577 0 011.573-1.576h1.761a1.572 1.572 0 011.573 1.575 1.577 1.577 0 01-1.573 1.576zM66.485 24.968a1.57 1.57 0 01-1.52-1.167 1.578 1.578 0 01.733-1.773l1.53-.882a1.57 1.57 0 012.139.581 1.577 1.577 0 01-.567 2.147l-1.53.882a1.56 1.56 0 01-.785.212zM55.056 13.403a1.572 1.572 0 01-1.57-1.576c0-.277.072-.548.21-.788l.88-1.532a1.573 1.573 0 112.724 1.576l-.88 1.531a1.576 1.576 0 01-1.364.79zM40.791 12.657a1.576 1.576 0 00-1.572-1.575 1.57 1.57 0 00-1.573 1.575V38.09L20.623 48.553a1.574 1.574 0 00-.124 2.599 1.571 1.571 0 001.77.085l17.769-10.924.024-.017c.025-.016.049-.034.073-.051l.058-.043c.02-.015.037-.032.056-.048l.063-.057.043-.045c.021-.023.043-.044.062-.068l.037-.047c.018-.024.037-.048.054-.073.018-.025.024-.036.037-.057.012-.02.029-.045.041-.069a.746.746 0 00.037-.07l.03-.063.033-.082.021-.058c.006-.02.018-.057.025-.086.008-.03.012-.043.015-.063l.017-.082.011-.074v-.07-.092-.029l.016-26.312z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#6F92B8",
                d: "M77.092 51.129a39.548 39.548 0 00-.874-25.815 39.47 39.47 0 00-16.62-19.75 39.369 39.369 0 00-48.332 6.286A39.54 39.54 0 005.97 60.38 39.435 39.435 0 0026.02 76.62a39.361 39.361 0 0025.785.354A18.288 18.288 0 0061.893 80c10.158 0 18.421-8.277 18.421-18.451a18.36 18.36 0 00-3.222-10.42zM3.074 39.452c0-20.055 16.29-36.372 36.312-36.372 20.023 0 36.312 16.317 36.312 36.372a36.568 36.568 0 01-1.064 8.777 18.342 18.342 0 00-12.737-5.134c-10.156 0-18.42 8.277-18.42 18.451a18.423 18.423 0 005.386 13.027 36.292 36.292 0 01-9.477 1.252c-20.021 0-36.312-16.316-36.312-36.373zm58.823 37.395c-3.021 0-5.975-.897-8.487-2.579a15.295 15.295 0 01-5.626-6.866 15.324 15.324 0 013.312-16.675 15.252 15.252 0 0116.647-3.317 15.28 15.28 0 016.855 5.636 15.319 15.319 0 012.575 8.5 15.33 15.33 0 01-4.48 10.814 15.28 15.28 0 01-10.796 4.487z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#6F92B8",
                d: "M72.041 55.968a1.572 1.572 0 00-2.227 0L59.653 66.144l-4.307-4.32a1.57 1.57 0 00-2.683 1.114c0 .418.165.818.46 1.113l5.423 5.433a1.572 1.572 0 002.224 0l11.272-11.291a1.575 1.575 0 000-2.225z"
            })
        ]
    });
}
/* harmony default export */ var saveTime = (SaveTime);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/benefits/icons/bonusBenefits.tsx


function BonusBenefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "83",
        height: "80",
        fill: "none",
        viewBox: "0 0 83 80",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#6F92B8",
            d: "M76.538 61.556a31.196 31.196 0 00-3.89-.708c1.996-1.468 3.342-4.187 3.342-7.294 0-4.294-2.583-6.962-6.74-6.962-4.156 0-6.739 2.668-6.739 6.962 0 3.1 1.34 5.814 3.33 7.285-1.305.151-2.602.39-3.888.72-3.934 1.011-6.1 3.196-6.1 6.153v9.263A3.029 3.029 0 0058.878 80h20.745a3.029 3.029 0 003.025-3.025v-9.263c0-2.949-2.227-5.192-6.11-6.156zm-7.288-12.38c1.552 0 4.156.568 4.156 4.377 0 3.182-1.903 5.87-4.156 5.87-2.253 0-4.157-2.688-4.157-5.87 0-3.809 2.605-4.378 4.157-4.378zm10.815 27.799c0 .24-.202.442-.442.442h-2.477V70.24a1.29 1.29 0 10-2.582 0v7.178H63.936V70.24a1.29 1.29 0 10-2.582 0v7.178h-2.476a.448.448 0 01-.442-.442v-9.263c0-2.134 2.262-3.163 4.16-3.65a26.41 26.41 0 016.593-.837c2.227 0 4.475.28 6.727.839 1.55.384 4.15 1.37 4.15 3.648v9.263zm-59.38-15.418a31.17 31.17 0 00-3.89-.71c1.997-1.467 3.342-4.186 3.342-7.294 0-4.293-2.582-6.96-6.74-6.96-4.157 0-6.739 2.667-6.739 6.96 0 3.101 1.34 5.815 3.33 7.286-1.305.151-2.602.39-3.888.72C2.166 62.57 0 64.755 0 67.712v9.263A3.029 3.029 0 003.025 80H23.77a3.029 3.029 0 003.025-3.025v-9.263c.001-2.949-2.226-5.192-6.11-6.156zM13.4 49.175c1.552 0 4.156.57 4.156 4.379 0 3.181-1.903 5.868-4.156 5.868-2.253 0-4.157-2.687-4.157-5.868 0-3.81 2.604-4.379 4.157-4.379zm10.814 27.8c0 .24-.202.442-.442.442h-2.476V70.24a1.29 1.29 0 10-2.582 0v7.178H8.085V70.24a1.29 1.29 0 10-2.583.001v7.178H3.026a.448.448 0 01-.442-.442v-9.264c0-2.134 2.262-3.163 4.16-3.65a26.41 26.41 0 016.593-.837c2.227 0 4.475.28 6.727.839 1.55.384 4.15 1.37 4.15 3.648v9.263zm24.4-30.533a31.193 31.193 0 00-3.891-.709c1.997-1.468 3.342-4.187 3.342-7.294 0-4.294-2.583-6.961-6.739-6.961s-6.74 2.667-6.74 6.96c0 3.101 1.34 5.815 3.33 7.286a29.08 29.08 0 00-3.888.72c-3.934 1.012-6.1 3.197-6.1 6.153v9.263a3.029 3.029 0 003.026 3.025h20.744a3.029 3.029 0 003.026-3.025v-9.263c-.001-2.95-2.228-5.192-6.11-6.155zM41.323 34.06c1.553 0 4.157.568 4.157 4.378 0 3.181-1.904 5.869-4.157 5.869s-4.156-2.688-4.156-5.87c0-3.809 2.604-4.377 4.156-4.377zM52.14 61.86c0 .24-.203.442-.443.442h-2.475v-7.178a1.29 1.29 0 10-2.582 0v7.178H36.01v-7.178a1.29 1.29 0 10-2.582 0v7.178h-2.475a.45.45 0 01-.444-.442v-9.263c0-2.133 2.263-3.163 4.16-3.65a26.41 26.41 0 016.593-.836c2.227 0 4.476.28 6.729.838 1.55.385 4.149 1.37 4.149 3.648l-.001 9.263zm9.384-33.938h2.307v12.383c0 .644.252 1.25.708 1.706a2.398 2.398 0 001.706.708h6.011a2.417 2.417 0 002.414-2.414V27.922h2.307c.73 0 1.375-.412 1.682-1.075a1.836 1.836 0 00-.269-1.977l-7.727-9.1a1.824 1.824 0 00-1.411-.653c-.554 0-1.055.232-1.412.653L60.11 24.87a1.836 1.836 0 00-.269 1.977c.306.662.95 1.074 1.68 1.074zm7.727-9.826l6.148 7.243h-2.021a1.292 1.292 0 00-1.291 1.291v13.506h-5.674V26.63a1.29 1.29 0 00-1.29-1.291H63.1l6.149-7.242zm-35.653-5.29h2.308V25.19c0 .644.252 1.25.708 1.706a2.398 2.398 0 001.706.708h6.011a2.417 2.417 0 002.414-2.414V12.806h2.307c.73 0 1.375-.411 1.682-1.074a1.834 1.834 0 00-.27-1.977l-7.727-9.1A1.826 1.826 0 0041.324 0c-.553 0-1.055.233-1.412.653l-7.727 9.102a1.834 1.834 0 00-.27 1.976 1.835 1.835 0 001.682 1.075zm7.727-9.825l6.149 7.242h-2.021a1.293 1.293 0 00-1.291 1.291V25.02h-5.674V11.514a1.29 1.29 0 00-1.291-1.29h-2.021l6.15-7.243zM5.671 27.92h2.307v12.384c0 .644.252 1.25.708 1.706a2.398 2.398 0 001.706.708h6.012a2.417 2.417 0 002.414-2.414V27.922h2.306c.73 0 1.376-.412 1.682-1.075a1.836 1.836 0 00-.269-1.977l-7.727-9.1a1.826 1.826 0 00-1.412-.654c-.554 0-1.055.232-1.412.653L4.258 24.87a1.835 1.835 0 00-.269 1.976 1.836 1.836 0 001.682 1.076zm7.17-10.48h.001zm.558.655l6.15 7.243h-2.022a1.292 1.292 0 00-1.291 1.291v13.506h-5.674V26.63a1.29 1.29 0 00-1.29-1.291H7.25l6.149-7.242z"
        })
    });
}
/* harmony default export */ var bonusBenefits = (BonusBenefits);

// EXTERNAL MODULE: ./src/components/warrantyforhouse/sharedButton/index.tsx
var sharedButton = __webpack_require__(89448);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/benefits/index.tsx






const benefitsList = [
    {
        title: "Seasoned Expertise",
        description: "With years of home warranty industry knowledge, we're well-versed in safeguarding homes. Countless homeowners have entrusted us with their protection.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(saveMoney, {})
    },
    {
        title: "Tailored Plans",
        description: "Our array of home warranty plans caters to your distinct needs and budget. Whether you're a first-time homeowner or a seasoned pro, we've got your back.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(saveTime, {})
    },
    {
        title: "Vast Network",
        description: "Our extensive network of reliable service providers ensures swift and dependable repairs whenever you require them.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bonusBenefits, {})
    }, 
];
function Benefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-center",
                children: "Why WarrantyFor.House?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-1 lg:text-lg text-base lg:leading-8 font-light text-center",
                children: "WarrantyFor.House is dedicated to fortifying your most cherished asset—your home. Here's why we're your ideal choice:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col lg:flex-row justify-center gap-7 mt-8",
                children: benefitsList.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:w-[371px] w-[300px] lg:mx-0 mx-auto rounded-[14px] bg-[#ECF5FF] lg:h-[471px] h-[460px] flex flex-col items-center px-6 relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mt-16 block",
                                children: el.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-9 font-bold lg:text-2xl text-xl text-[#6F91B8]",
                                children: el.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center mt-4 min-h-[196px] font-light lg:text-lg text-base lg:leading-8",
                                children: el.description
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center lg:mt-14 mt-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {
                    children: "Secure Your Free Home Warranty Quote Now!"
                })
            })
        ]
    });
}


/***/ }),

/***/ 68327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HowIsHomeWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/howIsHomeWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 465 317",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#ECF5FF",
                fillRule: "evenodd",
                d: "M119.215 76.674c16.769 0 32.721 3.468 47.197 9.712C192.406 35.13 245.611 0 307.026 0c87.021 0 157.565 70.522 157.565 157.516 0 86.993-70.544 157.513-157.565 157.513H119.215C53.373 315.029 0 261.67 0 195.851 0 130.033 53.373 76.674 119.215 76.674z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#95C3FF",
                fillRule: "evenodd",
                d: "M285.433 48.91h118.474c2.58 0 4.691 2.11 4.691 4.69v160.807a4.704 4.704 0 01-4.691 4.689H285.433a4.704 4.704 0 01-4.691-4.689V53.597c0-2.58 2.111-4.69 4.691-4.69",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M404.717 51.978H284.619v164.047h120.098V51.978z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#538ACE",
                fillRule: "evenodd",
                d: "M322.576 107.781h22.832c.762 0 1.384.622 1.384 1.383 0 .762-.622 1.384-1.384 1.384h-22.832a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#538ACE",
                d: "M344.84 31.504a3.347 3.347 0 11.002 6.693 3.347 3.347 0 01-.002-6.693zM309.548 56.49h70.582v-2.79c0-5.42-5.215-8.369-11.085-8.369h-7.85v-1.294a4.604 4.604 0 00-4.592-4.591h-3.333v-2.906c0-4.638-3.794-8.43-8.432-8.43-4.639 0-8.433 3.792-8.433 8.43v2.906h-3.333a4.606 4.606 0 00-4.592 4.591v1.294h-7.928c-8.421 0-11.007 4.383-11.007 8.369v2.79h.003z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B7D5FF",
                fillRule: "evenodd",
                d: "M322.576 115.07h69.23c.761 0 1.384.622 1.384 1.384 0 .761-.623 1.383-1.384 1.383h-69.23a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384zM322.576 122.356h69.23c.761 0 1.384.622 1.384 1.384 0 .761-.623 1.383-1.384 1.383h-69.23a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384zM322.576 140.147h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.384-1.387 1.384h-68.966a1.388 1.388 0 01-1.384-1.384c0-.761.622-1.384 1.384-1.384zM322.576 147.436h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.384-1.387 1.384h-68.966a1.388 1.388 0 01-1.384-1.384c0-.761.622-1.384 1.384-1.384zM297.068 187.911h40.936c.761 0 1.384.622 1.384 1.383 0 .762-.623 1.384-1.384 1.384h-40.936a1.388 1.388 0 01-1.385-1.384c0-.761.623-1.383 1.385-1.383zM296.917 195.2h67.492c.762 0 1.385.622 1.385 1.383 0 .762-.623 1.384-1.385 1.384h-67.492a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#95C3FF",
                fillRule: "evenodd",
                d: "M295.712 68.484h98.613c.692 0 1.256.565 1.256 1.257v25.862c0 .691-.564 1.256-1.256 1.256h-98.613a1.259 1.259 0 01-1.256-1.256V69.74c0-.692.564-1.257 1.256-1.257z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B7D5FF",
                fillRule: "evenodd",
                d: "M322.576 158.512h29.651c.762 0 1.385.622 1.385 1.383 0 .762-.623 1.384-1.385 1.384h-29.651a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383zM322.576 165.801h68.966a1.39 1.39 0 011.387 1.383c0 .762-.623 1.384-1.387 1.384h-68.966a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383zM322.576 173.087h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.383-1.387 1.383h-68.966a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#538ACE",
                fillRule: "evenodd",
                d: "M304.9 104.828c-6.193 0-11.214 5.02-11.214 11.212 0 6.191 5.021 11.211 11.214 11.211 6.194 0 11.215-5.02 11.215-11.211 0-6.192-5.021-11.212-11.215-11.212z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M297.56 122.101a9.37 9.37 0 007.323 3.514 9.365 9.365 0 007.01-3.143c-.26-2.881-.136-4.241-3.506-6.641a4.226 4.226 0 01-3.681 2.142 4.222 4.222 0 01-3.677-2.136c-3.316 2.449-3.125 3.54-3.469 6.264z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M304.706 110.548a3.195 3.195 0 00-3.196 3.196 3.195 3.195 0 003.196 3.196 3.195 3.195 0 100-6.392z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#77A5DF",
                fillRule: "evenodd",
                d: "M318.105 49.44h53.477a.79.79 0 01.788.787.79.79 0 01-.788.788h-53.477a.79.79 0 01-.788-.788.79.79 0 01.788-.787z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B7D5FF",
                d: "M310.087 138.237h-11.464c-.4 0-.762.165-1.025.428h-.003a1.45 1.45 0 00-.426 1.025v11.463c0 .4.165.761.429 1.025.263.263.628.428 1.025.428h11.464a1.447 1.447 0 001.453-1.453V139.69c0-.403-.162-.764-.423-1.025h-.002a1.433 1.433 0 00-1.026-.428m-11.464-1.74h11.464c.878 0 1.674.359 2.253.938h.003a3.2 3.2 0 01.938 2.255v11.463a3.18 3.18 0 01-.938 2.255 3.185 3.185 0 01-2.256.938h-11.464a3.18 3.18 0 01-2.255-.938 3.184 3.184 0 01-.938-2.255V139.69c0-.877.359-1.673.938-2.255a3.184 3.184 0 012.255-.938z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#EF8200",
                fillRule: "evenodd",
                d: "M302.708 147.066l5.948-5.544a1.153 1.153 0 011.625.058 1.152 1.152 0 01-.058 1.624l-6.825 6.357-.018.014a1.152 1.152 0 01-1.621-.107l-3.287-3.76a1.152 1.152 0 01.107-1.621 1.153 1.153 0 011.622.107l2.507 2.872z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B7D5FF",
                d: "M310.087 163.155h-11.464c-.4 0-.762.165-1.025.428h-.003a1.45 1.45 0 00-.426 1.025v11.463c0 .4.165.762.429 1.025.263.263.628.428 1.025.428h11.464c.402 0 .764-.162 1.025-.425.263-.266.428-.631.428-1.031v-11.463a1.45 1.45 0 00-.423-1.025h-.002a1.433 1.433 0 00-1.026-.428m-11.464-1.74h11.464c.878 0 1.674.359 2.253.938h.003a3.2 3.2 0 01.938 2.255v11.463a3.18 3.18 0 01-.938 2.255 3.185 3.185 0 01-2.256.938h-11.464a3.18 3.18 0 01-2.255-.938 3.184 3.184 0 01-.938-2.255v-11.463c0-.877.359-1.673.938-2.255a3.184 3.184 0 012.255-.938z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#EF8200",
                fillRule: "evenodd",
                d: "M302.708 171.981l5.948-5.544a1.153 1.153 0 011.625.058 1.152 1.152 0 01-.058 1.624l-6.825 6.357-.018.015a1.153 1.153 0 01-1.621-.107l-3.287-3.761a1.152 1.152 0 01.107-1.621 1.154 1.154 0 011.622.107l2.507 2.872z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C3E0FF",
                d: "M440.204 246.961c4.815-5.022 12.555-7.28 18.764-5.361-5.653 3.792-12.316 6.015-19.274 6.172-.857.402-1.711.804-2.565 1.213 6.092-1.277 12.477 1.048 15.645 5.783-6.292.241-12.379-1.939-16.291-5.474a381.32 381.32 0 00-4.407 2.151c6.133-.59 12.153 2.322 14.901 7.327-5.809-.431-11.238-2.782-15.799-6.878-1.436.718-2.87 1.447-4.297 2.185 2.725-.442 5.496.356 7.639 1.815 2.487 1.694 4.242 4.18 5.756 6.748-5.557-.889-10.621-3.5-14.49-7.992a389.608 389.608 0 00-4.685 2.486c5.826.553 10.914 4.215 12.967 9.374-5.783-1.077-10.928-4.18-13.239-9.226a371.02 371.02 0 00-5.56 3.068c6.779.504 12.767 4.707 15.107 10.711-5.985-1.835-11.305-5.222-15.712-10.369a385.056 385.056 0 00-4.581 2.637c3.214.452 6.156 1.928 8.264 4.171 2.294 2.441 3.582 5.77 3.571 9.238-4.848-3.231-8.954-7.428-12.429-13.062-1.12.658-2.238 1.323-3.35 1.992 5.322 2.452 9.09 7.506 9.895 13.307-4.683-2.941-8.325-7.283-10.092-13.185a383.837 383.837 0 00-5.615 3.453c5.091 2.154 8.696 6.933 9.345 12.413.069.573-.168 1.433-.765 1.375-.202-.02-.356-.159-.495-.292-3.501-3.379-6.469-7.272-8.267-13.38a367.404 367.404 0 00-8.754 5.677c5.682.396 10.746 3.809 12.869 8.759-5.56-.973-10.691-3.393-13.598-8.27a341.441 341.441 0 00-5.166 3.537c5.617.099 10.502 4.172 11.299 9.489-4.963-1.482-9.293-4.449-11.577-9.295a370.307 370.307 0 00-8.065 5.798l-1.381-.301a526.053 526.053 0 016.02-4.397c-2.548-1.751-3.535-5.213-2.997-8.641 2.522 1.792 3.964 4.846 3.857 8.025a409.664 409.664 0 014.153-2.936c-2.554-3.251-3.217-7.888-2.056-12.282 2.898 2.955 3.955 7.512 2.8 11.761a408.681 408.681 0 015.655-3.859c-3.373-3.103-4.818-7.303-4.665-11.636 3.956 2.003 6.185 6.507 5.592 11.017a351.9 351.9 0 013.228-2.122c-2.238-4.982-3.529-9.709-3.964-14.595 2.215 1.852 4.312 3.948 5.36 6.64.869 2.223.901 4.93-.24 7.205a302.063 302.063 0 015.406-3.404c-3.119-4.501-4.103-9.738-2.786-14.685 3.933 3.21 5.433 8.878 3.86 14.028a305.2 305.2 0 014.726-2.825c-2.186-5.709-2.259-11.11-.443-16.078 2.076 2.09 3.31 4.953 3.446 7.984.11 2.484-.521 5.069-1.778 7.384a255.636 255.636 0 014.784-2.697c-2.178-5.205-2.08-11.116.425-16.188 3.371 4.099 3.646 10.436.843 15.496 1.5-.814 3.006-1.613 4.52-2.397-1.439-5.995-.046-12.332 3.756-17.094 2.093 5.095 1.103 11.498-2.409 16.402a227.597 227.597 0 014.803-2.374c-.353-5.789 2.615-12.143 7.694-15.921-.159 5.489-2.588 11.116-6.611 15.403a218.86 218.86 0 015.673-2.582c1.584-6.363 5.513-12.045 10.847-15.753-.77 5.734-4.222 11.341-9.144 15.015a189.79 189.79 0 014.074-1.688"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C3E0FF",
                d: "M362.771 240.732a98.015 98.015 0 00-3.42 14.216 66.663 66.663 0 019.726 3.821 35.545 35.545 0 00-10.169-.744c-1.309 9.946-3.073 23.167-.854 32.569 6.5-2.269 15.045-8.629 21.231-12.566a124.175 124.175 0 00-7.193-5.535 77.47 77.47 0 0110.488 3.341 107.48 107.48 0 0017.081-14.636c-3.993-2.944-8.406-5.359-12.778-7.752a58.46 58.46 0 0116.792 3.262 100.864 100.864 0 006.174-8.062c.318-.463.628-.932.944-1.407 2.478-3.749 4.612-7.35 6.454-10.974-.895-.434-1.79-.865-2.684-1.3-4.654-2.252-9.322-4.516-13.975-6.768 6.156-.385 11.704 1.584 17.826 2.415.495.066.993.141 1.485.217v-.009c3.081-7.605 5.815-17.464 7.376-27.471a36.028 36.028 0 00-3.371-.828 38.297 38.297 0 00-3.457-.568 85.632 85.632 0 013.865-1.357 76.906 76.906 0 013.53-1.063c.663-4.788 1.231-10.004 1.761-15.779-7.048 2-13.529 3.995-19.488 6.25a90.09 90.09 0 01.203 3.517c.095 2.093.115 4.186.058 6.276a44.185 44.185 0 00-2.673-4.49 49.57 49.57 0 00-2.496-3.323c-6.284 2.686-11.939 5.815-17.044 9.761.764 1.395 1.506 2.799 2.27 4.197 1.946 3.601 3.898 7.188 5.843 10.798a123.066 123.066 0 00-7.439-7.83 126.5 126.5 0 00-4.389-4.039c-3.95 3.564-7.526 7.732-10.778 12.723a89.833 89.833 0 00-5.041 8.794c1.062 1.161 2.122 2.319 3.193 3.483 2.543 2.784 5.077 5.566 7.625 8.336-3.788-1.719-7.575-3.456-11.36-5.175-.701-.316-1.393-.637-2.088-.95a98.144 98.144 0 00-3.223 8.653"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#A7CAFF",
                d: "M417.418 198.413l-.2.243h.194c0-.078 0-.162.003-.243m-28.586 38.764l-.041.061.055-.023-.014-.038zm36.917-48.728c-.661.799-7.329 8.743-7.987 9.544a28.99 28.99 0 0110.387-.801l-.11.845a28.068 28.068 0 00-10.928 1.025l-.293.086c-1.96 2.418-3.9 4.852-5.814 7.304 5.102-.333 10.094.466 14.719 2.188.199.076.399.151.596.229l-.165.851c-.243-.095-.486-.191-.73-.281-4.749-1.768-9.888-2.536-15.13-2.078-.686.883-1.369 1.771-2.053 2.66 5.056.24 10.089 1.352 14.893 3.138.706.263 1.41.541 2.108.834-.067.281-.13.564-.197.842-.73-.31-1.465-.599-2.206-.877-4.92-1.832-10.075-2.938-15.232-3.112a518.659 518.659 0 00-4.242 5.639 93.14 93.14 0 0110.619 3.242 92.974 92.974 0 018.626 3.72c-.09.272-.183.544-.275.816a91.869 91.869 0 00-19.523-7.034 502.104 502.104 0 00-9.64 13.522 75.551 75.551 0 0114.044 3.731 73.971 73.971 0 018.864 3.98c-.133.249-.272.498-.411.747a73.154 73.154 0 00-8.751-3.928 74.906 74.906 0 00-14.279-3.755 530.833 530.833 0 00-3.665 5.422c5.968.188 11.907 1.378 17.513 3.465a55.788 55.788 0 016.718 3.02c-.148.243-.299.483-.449.726a55.004 55.004 0 00-6.565-2.947 54.404 54.404 0 00-17.75-3.424h-.023a500.017 500.017 0 00-6.77 10.479 83.977 83.977 0 0119.421 4.704 82.51 82.51 0 014.259 1.719c-.185.229-.37.458-.559.686a82.697 82.697 0 00-3.998-1.606 83.194 83.194 0 00-19.627-4.701 473.854 473.854 0 00-3.18 5.147 62.597 62.597 0 015.852 1.855 62.909 62.909 0 0113.813 7.199c-.206.206-.409.409-.614.611a61.954 61.954 0 00-19.511-8.907 529.26 529.26 0 00-3.194 5.335 46.747 46.747 0 0111.461 2.695 47.062 47.062 0 018.05 3.899c-.22.2-.44.4-.663.597a46.308 46.308 0 00-7.685-3.697 46 46 0 00-11.641-2.683 488.26 488.26 0 00-4.329 7.514c4.451.006 8.901.831 13.08 2.389a38.196 38.196 0 014.112 1.812c-.252.191-.504.382-.759.573a37.14 37.14 0 00-3.651-1.587c-4.237-1.577-8.76-2.385-13.266-2.33a517.383 517.383 0 00-4.974 9.064c2.768-.035 5.545.46 8.145 1.427.84.312 1.662.674 2.459 1.085l-.817.547a20.945 20.945 0 00-1.94-.83 21.758 21.758 0 00-8.311-1.364c-5.542 10.395-4.349 8.522-9.147 19.276h-.932c4.847-10.89 3.715-9.15 9.327-19.672-1.382-2.328-3.319-4.334-5.592-5.839l.069-.97a19.145 19.145 0 015.989 5.934c1.63-3.042 3.292-6.07 4.983-9.08a37.485 37.485 0 00-9.9-7.006l.113-.891a38.297 38.297 0 0110.222 7.127 507.429 507.429 0 014.424-7.68c-3.165-4.733-7.61-8.638-12.723-11.229.063-.287.13-.57.194-.857 5.2 2.594 9.735 6.508 13.007 11.272a523.371 523.371 0 013.107-5.193 56.826 56.826 0 00-14.8-11.133c.081-.278.162-.556.246-.834a57.765 57.765 0 0115.014 11.214 549.428 549.428 0 013.22-5.216c-4.392-5.179-9.943-9.411-16.117-12.314.098-.267.2-.536.301-.802 6.226 2.918 11.829 7.159 16.288 12.358a516.313 516.313 0 016.991-10.815c-3.061-7.55-7.848-14.428-13.862-20.012.159-.24.321-.48.484-.718 6.008 5.555 10.815 12.373 13.948 19.873a526.822 526.822 0 013.539-5.231c-3.287-7.341-7.862-14.132-13.448-19.991.185-.22.371-.437.556-.654 5.56 5.818 10.135 12.546 13.456 19.823 3.093-4.49 6.258-8.93 9.498-13.319-2.438-6.383-6.095-12.32-10.705-17.418.237-.162.475-.321.715-.48a56.56 56.56 0 0110.589 17.085 523.818 523.818 0 014.315-5.738c-1.509-5.607-4.407-10.864-8.331-15.215.261-.136.521-.272.785-.405 3.793 4.253 6.631 9.333 8.197 14.769.623-.81 1.246-1.621 1.871-2.426a45.678 45.678 0 00-7.068-13.802l.793-.365a46.504 46.504 0 016.912 13.348 507.447 507.447 0 016.452-8.099 36.9 36.9 0 00-1.338-9.941l.811-.275a37.767 37.767 0 011.369 9.179c.553-.677 7.124-8.496 7.68-9.167a.423.423 0 01.599-.058c.183.15.209.419.058.599l.009.017z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#000446",
                d: "M421.715 315.365H4.925v.784h416.79v-.784z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M83.749 307.65l.559-5.833-5.905.139.058 6.678 5.288-.984z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M84.038 307.155c1.668 2.973 4.387 5.813 2.265 8.34H75.496a5.079 5.079 0 01-.052-.157c-.104-.347-.608-.489-.272-1.757.625-2.35 2.467-5.963 3.098-6.148 1.254-.368 3.035.669 5.765-.278",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1D3975",
                fillRule: "evenodd",
                d: "M87.11 313.529v.006c.024.79-.057 1.488-.804 1.96H75.499c-.559-.321-.704-.541-.324-1.914l11.936-.052z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M101.847 226.799l-6.324 25.468-3.229 15.163-7.167 36.929s-1.517.686-3.94.547c-2.424-.139-3.65-.495-3.65-.495-.052-10.905-.327-25.567-.422-38.747-.084-11.59-.385-21.896-.429-30.687-.02-3.804 4.344-14.567 4.286-14.428l20.869 6.253.006-.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M109.839 307.65l-.023-6.033-5.902.139.634 6.878 5.291-.984z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M110.23 306.359s9.266 3.778 11.866 5.04c2.019.981 3.162 3.045 1.506 4.096h-20.203a4.748 4.748 0 01-.052-.156c-.301-.99-1.086-8.062 1.016-7.906 1.306.098 2.948.414 5.867-1.077",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1D3975",
                fillRule: "evenodd",
                d: "M124.407 313.529v.006l.014.44c-.031.628-.286 1.181-.822 1.523h-20.296l-.052-.157c-.058-.193-.202-1.198-.272-1.757l21.431-.052-.003-.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M110.334 225.43c1.818 25.894 2.154 49.616.067 78.908 0 0-2.832.605-5.256.467-2.424-.139-1.981-.417-1.981-.417l-5.672-40.203s-1.283-9.153-4.286-16.289c-2.169-5.152-4.827-6.637-4.433-12.624.405-6.2-.119-11.006.741-13.148.86-2.142 5.157-1.282 5.157-1.282l15.669 4.585-.006.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1D3975",
                fillRule: "evenodd",
                d: "M98.76 273.625l-1.271-9.075s-.701-5.031-2.273-10.56l1.201-8.603 2.496 21.571-.153 6.667z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#AEC2FD",
                fillRule: "evenodd",
                d: "M99.736 193.57c2.736 6.004 4.775 11.999 11.047 16.81 10.109 7.758 20.284 10.74 21.706 9.938 1.219-.689 4.601-3.031.397-5.836-2.766-2.232-13.546-11.432-16.338-13.328-.987-.671-7.335-19.198-15.952-22.341-.869-.559-3.403 10.93-.86 14.757z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#9BB3FB",
                fillRule: "evenodd",
                d: "M102.672 200.037c1.836 3.726 4.112 7.275 8.111 10.343 4.954 3.801 11.038 6.913 15.883 8.916-1.587-1.531-3.779-2.414-9.759-7.877-5.979-5.462-10.334-11.941-10.334-11.941l-3.904.559h.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#AEC2FD",
                fillRule: "evenodd",
                d: "M74.097 200.075c1.06 7.008 2.54 20.998 1.938 31.92 14.13 2.426 26.715 1.934 35.153-.752-1.445-11.258.808-49.935-12.043-52.978-4.645-1.299-8.253-1.183-13.175-.683-8.74.892-31.71 15.412-35.912 21.853-2.948 4.519-4.987 11.012-5.551 15.736-.209 1.745 3.874 4.464 5.956 2.631 6.59-2.46 23.191-16.978 23.634-17.727z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#9BB3FB",
                fillRule: "evenodd",
                d: "M74.167 200.549c1.1 7.006 2.131 22.655 1.868 31.446 12.883 2.212 24.83 2.212 33.708-.362-5.678.658-27.375 1.002-29.07-4.44-.966-3.112-1.731-21.766-3.495-30.847-1.245 1.367-2.22 2.041-3.011 4.203z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M98.937 170.759c-.994 1.978-2.062 3.422-3.614 4.166l.052 2.875.42.356c1.639 1.754-.484 3.415-2.349 3.305-7.331.362-5.032-2.188-6.257-4.217l.71-4.267c-.244-.015-2.288-1.08-2.815-1.242-.527-.162-1.3-1.178-1.353-2.249-.052-1.071 1.605-.724 1.605-.724-2.007-2.747-4.28-4.991-1.332-7.463 2.947-2.472 9.718-3.916 9.718-3.916l4.074-1.413c-.519 1.407.173 6.096 1.222 9.023.938 2.626 1.254 3.115-.081 5.769",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E98385",
                fillRule: "evenodd",
                d: "M89.546 173.478s2.305 3.951 4.199 4.31c1.893.359.926.093 1.63.009l-.052-2.875c-1.306.209-2.58.107-5.777-1.447",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M93.447 181.459c-.87 1.01-2.404 2.628-3.273 3.638-2.287-2.119-3.483-4.154-4.676-7.115.423-.428 1.271-.903 1.694-1.332.964 1.865 2.745 3.529 6.255 4.806",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M93.446 181.458c.98.88 2.58 1.957 3.56 2.837.361-1.994.118-4.168-.525-6.464l-1.074-.582c-.078 1.613-1 2.976-1.96 4.209z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                d: "M59.512 226.301l3.68 30.445-3.3 50.603c.11.15.22.301.33.446.083.116.167.226.254.336.203.266.403.518.603.755.09.107.18.211.272.313 1.488 1.638 3.408 2.035 4.983 2.417 1.22.298 2.157.443 2.986 2.072a.93.93 0 01-.854 1.341l-14.444-.452a1.392 1.392 0 01-1.352-1.531l.964-6.302s0-.009.003-.026c-.35-12.303-3.136-30.334-.855-44.707 0 0-2.808-15.582-2.753-16.24.055-.651 9.477-19.467 9.477-19.467M47.576 251.329c-.628 5.416 3.15 8.63 2.525 14.046-.009 13.559-9.512 29.179-12.727 42.871-.107.455.704 4.759.611 5.208-1.427 1.525-5.495 3.679-5.93-3.358 1.819-11.822 4.083-30.928 8.765-45.309l-2.956-14.338 9.715.88h-.003z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M67.753 222.541c1.468 8.618.669 30.653-.953 47.683-11.73 3.01-28.991 2.194-33.303-1.448 2.879-22.211 4.34-43.554 8.94-47.486 4.87-5.78 23.897-4.495 25.316 1.251z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M46.143 186.982s.782 8.823 2.652 19.913c1.87 11.087-.559 15.536-.559 15.536l14.595-.347s-.953-12.949-2.534-20.88c-1.581-7.932-3.38-15.855-3.38-15.855l-3.88.593-6.683-.11-.214 1.147.003.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M55.71 190.893c3.91-.964 3.643-2.727 3.643-2.727l-4.187-3.729-9.573.767-.574 3.746 1.34 2.053c3.22-.087 5.445.854 9.354-.11",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFBC4A",
                d: "M36.303 186.348c-2.76 11.252 8.708 25.836 1.923 42.359 3.7.515 9.443 1.965 13.879 1.3.533-2.791 2.32-7.585 1.15-21.144-1.173-13.559-6.947-23.343-6.947-23.343l1.091.205 5.088.11 2.954-.593s3.225 8.571 4.323 15.8c1.097 7.228.927 25.227 1.181 29.338 3.585-.258 9.941.515 8.815-2.828-.831-2.469-2.994-13.733-3.078-17.412-.145-6.597 1.639-9.527.518-13.357-1.24-4.235-4.627-11.278-6.741-12.137-9.982-2.797-20.05-4.421-24.159 1.705"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#EF7E05",
                d: "M62.413 228.148c1.06 3.645 8.653 2.22 7.35-.596-.634-1.372-1.938-8.708-2.522-12.248-.701 5.022-5.693 10.187-4.828 12.844z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E69A1A",
                d: "M37.053 200.729c2.186 5.624 4.106 12.954 2.708 25.659 1.224.171 8.915 3.413 10.236 3.54.787-2.848-4.581-4.84-7.338-9.144-.04-.599-.197-1.621-.249-2.226-.625-7.448-1.96-15.137-3.99-20.565l-1.367 2.733v.003z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M54.418 180.963l.05 2.73.396.339c1.555 1.667-.127 5.089-1.9 4.982a7.809 7.809 0 01-4.583-1.213c-1.865-1.201-2.803-3.025-1.99-4.232l.586-.652.13-3.861c-.232-.012-1.914-.97-2.415-1.123-.501-.154-1.237-1.118-1.286-2.137-.05-1.019 1.526-.689 1.526-.689-1.908-2.608-4.065-4.738-1.265-7.089 2.8-2.351 9.231-3.72 9.231-3.72l3.872-1.34c-.493 1.334.165 5.789 1.16 8.571 1.414 3.955.63 7.454-3.509 9.437",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E98385",
                fillRule: "evenodd",
                d: "M48.931 179.591s2.19 3.755 3.988 4.094c1.798.338.88.089 1.549.008l-.05-2.73c-1.239.2-2.452.102-5.487-1.375",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFBC4A",
                d: "M37.566 185.311c-9.933 4.117-11.195 25.495-9.16 31.605 1.712 4.956 14.78 18.09 19.043 16.307 2.056-.86 4.04-3.674.944-5.68-4.52-2-11.018-11.582-11.279-12.815-1.225-9.113 6.072-30.305.449-29.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M48.775 229.074l1.755.97c.538.009 8.238-.353 7.019.68-.707.597-2.682 1.422-2.656 1.509.365 1.129 4.251 1.331 4.289 1.432.538 1.445-3.081.799-3.686.579-.16-.057 2.516 1.014 2.25 1.344-.513.639-2.392-.319-3.284-.423-.217-.026 2.247.909 2.035 1.349-.723.411-2.652-.567-3.188-.643-.127-.017 1.938.903 2.097 1.181.133.238-.267.478-.556.38-4.271-1.422-2.844-2.878-7.778-4.374-2.745-.834.116-4.603 1.697-3.984",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M49.545 170.424s5.557.188 7.627-1.607c4.344-3.731 1.7-12.63-9.402-9.336-8.835 2.623-4.512 11.296-16.007 14.885-4.26 1.332-3.753 3.465-.015 4.913-2.55.9-.084 3.395 2.273 3.097-4.497 3.601 5.239 6.403 12.373 1.193 4.104-3.008-3.11-12.208 3.154-13.145M65.891 311.147s5.03 1.392 4.804 2.941c-.457 3.129-17.719 1.062-17.811.95-.611-.762-.684-4.293.139-5.347.614-.785 5.617 3.873 12.868 1.456zM39.57 315.642c-.11 2.009-7.535 1.358-8.627.756-1.624-.897.275-5.289 1.132-6.441 2.375 4.912 5.314 1.552 5.876 1.76.715 1.413 1.72 2.073 1.621 3.925",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFBC4A",
                fillRule: "evenodd",
                d: "M58.177 184.753c11.044-1.352 18.428 17.406 19.71 23.945.986 5.335-6.984 20.782-11.73 21.346-1.106.13-3.972-1.89-2.617-4.49 3.052-4.102 6.211-12.583 5.814-13.822-1.358-3.384-3.648-5.387-6.425-7.089-2.018-1.239-1.303-5.796-2.693-10.225-1.37-4.368-4.88-8.609-2.059-9.665z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E69A1A",
                fillRule: "evenodd",
                d: "M69.042 210.976c-.287-.558-2.022-2.26-2.346-2.747.177-5.297 1.514-8.01.51-11.451-.773-2.643-2.383-6.381-4.002-9.026 1.89 2.559 3.999 7.257 4.92 10.403 1.019 3.483 1.068 7.399.918 12.821z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F4B1B1",
                fillRule: "evenodd",
                d: "M63.531 226.799l-1.118 1.349c-.434.18-6.81 2.354-5.49 2.802.765.258 2.638.295 2.641.374.067 1.036-3.466 4.895-3.463 4.987.026 1.346 2.41-.972 2.832-1.346.11-.098-1.294 1.575-1.147 1.986.058.159.611.125 1.066-.301.559-.521 1.37-1.569 1.555-1.557.19.011-1.263 1.696-1 1.997.166.182.42 0 .762-.333.565-.556 1.254-1.572 1.457-1.609.205-.038-1.002 1.537-.976 1.728.035.252.319.159.428.063 3.018-2.527 1.628-4.165 5.16-6.964 1.964-1.558-1.54-4.348-2.71-3.182M135.298 216.656c.816-.2 4.059-.952 4.804-.669.379.145.295.264.191.458-.09.17-.429.437-.704.532-.573.197-1.326 1.002-1.656 1.063 1.442 3.149 6.008 4.446 4.986 5.963-.342.136-2.493.182-3.043.339-1.749.5-2.667.561-7.874-3.955-1.76-1.525-.133-3.169 1.277-4.009l2.016.281.003-.003z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#355298",
                fillRule: "evenodd",
                d: "M97.442 161.218c-3.486 1.954-7.662-.052-9.642 2.464-.979 1.245-.811 2.981.437 5.627.368.779.843 1.346-.518.776-.626-.261-1.65-.62-1.987-.33-.747.651-.31 1.942.322 2.339.28.177.81.437.81.437-9.26-.57-13.444-21.806 6.938-20.191.577.046.18-1.624.78-1.644 4.578-.171 8.646 6.884 2.86 10.522z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#3D7DDA",
                d: "M193.909 140.457H172.33v38.156h21.579v-38.156z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1A60C8",
                fillRule: "evenodd",
                d: "M217.022 134.754h91.964l81.099 69.475h-159.96c0 20.063-13.103-60.165-13.103-69.475z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DF9400",
                d: "M381.543 204.229h-96.846v111.089h96.846V204.229z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#3D7DDA",
                fillRule: "evenodd",
                d: "M390.085 204.229H276.511l8.189 4.035h105.388v-4.035h-.003zm-231.949-3.758l-19.456 3.758v4.035h10.668l8.788-7.796v.003zm-19.456 3.758l78.342-69.475 78.343 69.475h-18.857l-4.613-3.758H158.136l-19.456 3.758z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFBC4A",
                fillRule: "evenodd",
                d: "M284.697 208.267v107.054H149.348V208.267l67.674-60.017 67.675 60.017z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DE7405",
                fillRule: "evenodd",
                d: "M214.645 213.448h24.535l2.126 2.189v99.684h-24.533l-2.128-2.188v-99.685z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M194.868 309.407v-95.959h44.312v101.873h-44.312v-5.914z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#024BC8",
                d: "M236.116 216.338h-38.185v93.231h38.185v-93.231z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DE7405",
                fillRule: "evenodd",
                d: "M249.283 213.666h24.532l2.129 2.061v54.32h-24.533l-2.128-2.064v-54.317z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M273.815 213.666h-24.532v54.317h24.532v-54.317z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#105DC4",
                d: "M270.755 216.725h-18.408v48.192h18.408v-48.192z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DE7405",
                fillRule: "evenodd",
                d: "M159.734 213.666h24.532l2.129 2.061v54.32h-24.532l-2.129-2.064v-54.317z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M184.266 213.666h-24.532v54.317h24.532v-54.317z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#105DC4",
                d: "M181.203 216.725h-18.405v48.192h18.405v-48.192zM236.116 216.338h-38.185v93.231h38.185v-93.231z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B9E4FF",
                d: "M232.653 218.619H201.29v27.862h31.363v-27.862z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#B9E4FF",
                fillRule: "evenodd",
                d: "M232.653 279.441v27.862H201.29V248.935h31.363v30.506z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C8EDFD",
                fillRule: "evenodd",
                d: "M252.347 240.633l18.405-19.088v4.143l-18.405 19.085v-4.14zM252.347 248.301l18.405-19.088v7.614l-18.405 19.085v-7.611zM162.798 240.633l18.408-19.088v4.143l-18.408 19.085v-4.14zM162.798 248.301l18.408-19.088v7.614l-18.408 19.085v-7.611z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#DE7405",
                fillRule: "evenodd",
                d: "M194.868 177.076h44.312l2.125 2.064v27.075h-44.309l-2.128-2.064v-27.075z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M239.18 177.076h-44.312v27.075h44.312v-27.075z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#105DC4",
                d: "M236.056 180.196h-38.067v20.834h38.067v-20.834z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#CD6615",
                fillRule: "evenodd",
                d: "M299.332 213.666h24.532l2.129 2.061v54.32H301.46l-2.128-2.064v-54.317z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M323.864 213.666h-24.532v54.317h24.532v-54.317z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#105DC4",
                d: "M320.801 216.725h-18.405v48.192h18.405v-48.192z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C8EDFD",
                fillRule: "evenodd",
                d: "M302.396 240.633l18.405-19.088v4.143l-18.405 19.085v-4.14zM302.396 248.301l18.405-19.088v7.614l-18.405 19.085v-7.611z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#3D7DDA",
                d: "M195.276 134.754h-24.489v8.601h24.489v-8.601z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C8EDFD",
                fillRule: "evenodd",
                d: "M197.989 201.03l19.876-20.834h3.95l-19.876 20.834h-3.95zM205.304 201.03l19.876-20.834h7.259l-19.873 20.834h-7.262z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#CD6615",
                fillRule: "evenodd",
                d: "M338.496 213.666h24.535l2.126 2.061v54.32h-24.533l-2.128-2.064v-54.317z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M363.028 213.666h-24.532v54.317h24.532v-54.317z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#105DC4",
                d: "M359.965 216.725H341.56v48.192h18.405v-48.192z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C8EDFD",
                fillRule: "evenodd",
                d: "M341.56 240.633l18.408-19.088v4.143l-18.408 19.085v-4.14zM341.56 248.301l18.408-19.088v7.614l-18.408 19.085v-7.611z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/howIsHomeWarranty/index.tsx



function HowIsHomeWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-44 gap-16 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 order-1 lg:order-2 lg:mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "Demystifying Home Warranties"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 lg:text-lg text-base lg:leading-8 font-light",
                        children: "Imagine a home warranty as a protective cocoon for your home's vital systems and appliances. It's a service agreement that ensures coverage for major components, shielding you from unforeseen breakdowns. Think of it as your home's trusty ally, always ready to step in when you need it the most."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[200px] md:h-[267px] md:w-[391px] md:min-w-[391px] relative mx-auto lg:mx-0 order-2 lg:order-1 lg:ml-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 78861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LeaveHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/leaveHome/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 391 355",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_601)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D9E7FF",
                        d: "M81.891 144.708S64.2 60.102 137.492 37.468c63.519-19.616 61.062-44.873 111.607-35.421 50.545 9.45 50.058 65.238 100.013 89.07 41.051 19.583 81.089 166.08-31.657 174.007C247.186 270.066 81.893 144.71 81.893 144.71l-.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E8EEFA",
                        d: "M66.888 235.16c-.695-3.99-7.33-6.573-14.823-5.767-.5.054-.99.124-1.47.203-3.662-1.502-8.564-2.158-13.776-1.597-10.122 1.087-17.566 6.339-16.628 11.727.925 5.311 9.646 8.772 19.583 7.833 2.2 2.789 7.75 4.398 13.878 3.741 7.492-.804 13.001-4.691 12.308-8.681-.162-.924-.653-1.768-1.388-2.516 1.73-1.46 2.62-3.191 2.316-4.943z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M37.643 217.189c10.286-.388 17.61-12.97 17.199-22.302-.153-3.486-5.61-3.506-5.455 0 .151 3.426 2.794 6.379.87 9.269-2.011 3.022-4.426 9.911-12.437 9.481-3.496-.189-3.693 3.684-.177 3.552z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M35.236 244.905c-1.158 0-2.104-1.158-2.104-2.574V206.73c0-1.416.947-2.574 2.104-2.574 1.158 0 2.103 1.158 2.103 2.574v35.601c0 1.416-.947 2.574-2.103 2.574z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#879FD4",
                        d: "M34.976 186.625c12.142-1.23 21.108-10.832 20.027-21.447-1.081-10.615-11.8-18.223-23.942-16.994-12.142 1.23-21.108 10.832-20.027 21.447 1.081 10.615 11.8 18.223 23.942 16.994z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#879FD4",
                        d: "M41.343 207.603c12.142-1.23 21.108-10.832 20.027-21.447-1.081-10.615-11.8-18.224-23.942-16.994-12.142 1.23-21.108 10.832-20.027 21.447 1.081 10.615 11.8 18.223 23.942 16.994z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#879FD4",
                        d: "M36.914 181.352c0 7.909-7.333 14.319-16.377 14.319-9.045 0-16.378-6.412-16.378-14.319 0-7.907 10.438-14.059 19.483-14.059s13.272 6.151 13.272 14.059zM49.324 159.798c5.404-.129 11.725 4.635 11.873 10.782.148 6.146-4.666 12.453-10.07 12.582-5.405.128-9.904-4.748-10.052-10.895-.148-6.147 2.845-12.34 8.249-12.469z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91ABE3",
                        d: "M46.184 168.038c1.284-5.098-3.89-10.788-11.555-12.708-7.666-1.92-14.921.657-16.205 5.755-1.284 5.098 3.889 10.787 11.555 12.708 7.665 1.92 14.92-.657 16.205-5.755zM28.356 182.991c.554-3.029-2.687-6.156-7.24-6.985-4.552-.829-8.693.954-9.247 3.982-.555 3.028 2.686 6.155 7.239 6.984 4.553.83 8.693-.953 9.248-3.981z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D9E7FF",
                        d: "M189.545 338.709l86.163 2.798a60.676 60.676 0 0033.222-8.631l68.427-41.112c6.923-4.16 6.741-14.23-.328-18.137L312.032 237.7 189.545 338.707v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ADC1F0",
                        d: "M64.2 263.144V158.196l41.272-24.225 17.527 2.3 66.546 65.521V335.26l-24.012-13.825v.049L64.2 263.144z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D9E7FF",
                        d: "M189.545 201.919l16.952-9.758v-.353l1.437-.475 69.071-19.346 3.531-3.43 39.078 8.459-1.541 84.369-98.669 56.808v-.122l-29.859 17.189V201.919z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3B57B3",
                        d: "M244.674 67.285l74.94 104.702-128.712 72.535-73.622-108.297 127.394-68.94z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2E4DA3",
                        d: "M117.28 136.225l-72.62 30.402 32.42-21.132 119.745-61.684 47.849-16.526-127.394 68.94z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M319.614 171.987v5.029l-128.807 72.033.071-4.524 128.736-72.538z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M190.807 249.049L117.28 142.706v-6.481l73.622 108.297-.095 4.527zM117.28 142.706l-72.62 29.281v-5.36l72.62-30.402v6.481z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M94.186 240.891l-22.24-12.805v-35.819l22.24 12.805v35.819z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M94.186 240.891v-35.818l-18.357-10.569v35.818l18.357 10.569z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M94.184 235.835v-27.04l-13.857-7.98v27.042l13.857 7.978zM171.11 281.295l-22.24-12.806v-35.818l22.24 12.804v35.82z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M171.11 281.295v-35.819l-18.356-10.569v35.818l18.356 10.57z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M171.108 276.238v-27.041l-13.857-7.978v27.039l13.857 7.98z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#223B82",
                        d: "M222.432 280.101l22.242-12.804v-35.82l-22.242 12.806v35.818z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M222.432 280.101v-35.818l18.357-10.569v35.818l-18.357 10.569z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#223B82",
                        d: "M222.434 275.044v-27.039l13.859-7.978v27.039l-13.859 7.978zM271.358 252.87l22.24-12.804v-35.82l-22.24 12.806v35.818z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M271.358 252.87v-35.818l18.356-10.568v35.818l-18.356 10.568z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#223B82",
                        d: "M271.358 247.813v-27.039l13.858-7.978v27.039l-13.858 7.978z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M189.545 338.709v-14.235L64.133 252.347v14.212l125.412 72.15z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#223B82",
                        d: "M189.545 338.709v-14.235l128.727-74.034-.819 14.683-127.908 73.586z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M106.208 208.75v70.63l25.851 14.881v-.057l6.162 3.549v-70.631l-32.013-18.372z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M115.052 284.471l17.007 9.79v-.057l6.162 3.549v-70.631l-23.169-13.297v70.646z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M135.904 249.049l-15.318-8.819v-16.92l15.318 8.82v16.919zM117.637 255.634c-.609-.334-1.105-1.104-1.105-1.711v-4.862c0-.607.498-.829 1.105-.493.609.334 1.105 1.104 1.105 1.711v4.861c0 .607-.498.829-1.105.494zM68.648 285.529v13.412l63.006 36.275 26.587-15.307v-13.413l-89.593-20.967z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3457B8",
                        d: "M158.241 306.496l-63.006-36.274-26.587 15.307 63.006 36.274 26.587-15.307z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D9E7FF",
                        d: "M131.654 335.216l57.891 3.493-31.304-18.8-26.587 15.307z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2.77",
                        d: "M64.133 165.672v86.675"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#6F8BE8",
                        d: "M195.213 180.737l66.446-36.554c2.622-1.443 1.991-4.28-1.403-6.306-3.394-2.027-8.316-2.503-10.939-1.06l-66.446 36.554c-2.623 1.443-1.992 4.28 1.402 6.306 3.395 2.026 8.316 2.503 10.94 1.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#032F45",
                        d: "M201.498 184.976l66.446-36.554c2.622-1.443 1.991-4.28-1.403-6.306-3.394-2.027-8.316-2.503-10.939-1.06l-66.446 36.554c-2.623 1.443-1.992 4.28 1.402 6.306 3.395 2.027 8.316 2.503 10.94 1.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0B037",
                        d: "M203.484 162.732c-1.645-.58-12.347-7.502-13.575-8.981-4.379-3.986-6.838-10.457-6.433-18.737.889-18.169 15.207-38.136 31.979-44.597 7.817-3.011 14.111-3.457 19.651-.337 3.084 1.546 11.429 6.286 11.429 6.286 1.539 1.487-1.465 2.155-.478 4.254 2.171 3.782 3.282 8.659 2.999 14.419-.889 18.169-15.207 38.136-31.979 44.597-7.063 2.721-8.648 5.492-13.593 3.098v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M246.256 143.751c12.149-18.173 12.293-39.357.321-47.316-11.972-7.96-31.527.32-43.676 18.494-12.15 18.173-12.293 39.357-.321 47.316 11.972 7.959 31.526-.322 43.676-18.494z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFD482",
                        d: "M247.485 144.466c12.149-18.173 12.293-39.357.321-47.316-11.972-7.96-31.527.321-43.676 18.494-12.15 18.173-12.293 39.357-.321 47.316 11.972 7.959 31.526-.321 43.676-18.494z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M241.569 140.447c8.494-12.704 8.594-27.514.224-33.078-8.37-5.564-22.04.224-30.533 12.929-8.494 12.704-8.594 27.514-.224 33.078 8.369 5.564 22.04-.224 30.533-12.929z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2C97B",
                        d: "M246.028 121.371c-.73 13.17-10.968 27.371-22.87 31.717-4.744 1.733-9.036 1.637-12.435.061 3.632 2.585 8.674 3.139 14.367 1.06 11.902-4.346 22.14-18.545 22.87-31.718.438-7.92-2.663-13.663-7.794-16.039 3.959 2.818 6.243 8.049 5.862 14.919z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFD482",
                        d: "M227.763 117.018c2.265-.587 4.93-.592 6.69.402l-2.587 4.804c-1.918-.741-3.589-.882-5.44-.18-2.157.817-3.149 2.08-3.205 3.88-.126 4.025 10.05.095 9.831 7.13-.119 3.831-2.437 7.336-6.083 9.45l-.126 4.026-3.738 1.416.123-3.948c-2.456.582-4.19.002-5.642-1.031l2.953-4.363c1.347.765 2.522.977 4.139.363 1.851-.7 2.876-1.823 2.93-3.581.116-3.714-10.066.452-9.835-7.014.117-3.752 2.25-7.418 6.246-9.781l.125-4.064 3.738-1.416-.122 3.909.003-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#FFD482",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "4.24",
                        d: "M201.317 116.497l-9.635-5.475M196.597 125.518l-9.341-5.378M193.789 135.063l-9.34-5.377M193.138 144.708l-8.615-4.958M195.383 154.216l-8.63-5.236M207.716 107.905l-9.301-5.44M215.236 101.095l-9.302-5.441M223.847 96.068l-8.577-5.016M233.674 93.566l-8.841-4.902"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFFCFA",
                        d: "M279.332 73.683c.131-8.58-3.408-17.083-8.77-20.169a8.622 8.622 0 00-2.535-.987c-1.576-7.698-5.362-14.369-10.414-17.279-5.164-2.974-10.378-1.282-13.945 3.71-.999-1.175-2.107-2.14-3.308-2.831-5.361-3.087-11.145 3.454-7.783 10.638l46.755 26.918zM154.473 87.264c.088-5.84-2.32-11.628-5.971-13.729a5.86 5.86 0 00-1.726-.671c-1.073-5.24-3.649-9.781-7.087-11.762-3.515-2.024-7.064-.871-9.492 2.525-.679-.8-1.434-1.456-2.252-1.928-3.649-2.1-7.585 2.352-5.297 7.243l31.825 18.322zM335.863 139.372c.089-5.84-2.319-11.627-5.97-13.728a5.873 5.873 0 00-1.726-.672c-1.073-5.239-3.649-9.78-7.089-11.761-3.515-2.025-7.064-.872-9.492 2.525-.679-.801-1.434-1.457-2.252-1.928-3.649-2.101-7.586 2.352-5.297 7.242l31.825 18.322h.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#20377A",
                        d: "M131.654 335.216v-13.413l26.587-15.307v13.413l-26.587 15.307z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E8EEFA",
                        d: "M.005 335.423c.255-4.836 8.875-8.852 18.154-8.365 8.057.424 17.507 3.774 18.933 7.803 6.243-.524 12.803.438 17.367 2.863 7.328 3.89 6.743 10.074-1.306 13.811-8.048 3.737-20.512 3.614-27.84-.276-3.506-1.862-5.196-4.25-5.127-6.642-.025 0-.05 0-.076-.004-9.281-.488-20.362-4.354-20.107-9.19h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M25.257 332.016l3.272.794c2.45-.151 3.697-.49 4.423.398l.206.253c.726.888.248 1.789-1.063 1.999l-5.98 1.894c-1.31.21-2.682-.534-3.254-1.611 0 0-.337-.656.772-2.462.633-1.029.575-1.097 1.624-1.267v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M11.524 308.285l-8.007 19.507c-.925 2.398 2.171 2.701 3.088 1.382l10.917-24.691-6 3.804.002-.002zM23.589 289.936l.177 43.591c-.03 2.725 2.879 1.947 3.263.305l2.853-40.49-6.293-3.406z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M33.365 277.617l-5.642 52.424s-2.23 3.094-4.858-.257c-1.027-8.305-1.553-15.998.114-21.011l.124-22.591-.61-9.139 10.872.572v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M23.19 279.85l-3.415 23.533a6.475 6.475 0 01-.597 1.928l-9.025 18.416s-3.917 2.134-5.52-2.275c2.526-10.273 5.434-16.472 8.673-19.172a3.54 3.54 0 00.3-1.124l2.356-24.679 7.227 3.374v-.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M27.322 294.518l-9.072-4.146a5.333 5.333 0 01-3.044-5.752l.869-5.045 15.43 7.644-4.183 7.3v-.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M29.202 252.856c-.085 3.024-2.287 3.468-4.54 2.086-2.253-1.382-3.704-4.066-3.62-7.09.083-3.023 1.979-4.354 4.232-2.972 2.253 1.382 4.011 4.953 3.928 7.976z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M31.947 251.199c-.085 3.024-2.848 4.82-5.102 3.438-2.253-1.382-4.011-4.954-3.928-7.977.085-3.023 1.98-4.354 4.233-2.972 2.253 1.382 4.882 4.488 4.797 7.513v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M23.613 261.806l-.274-.1c-.925-.337-.845-1.623-.4-2.834l2.036-6.808c.444-1.21 1.564-1.924 2.49-1.587l.273.1c.925.338 1.316 1.604.872 2.815l-1.673 6.829c-.444 1.21-2.4 1.922-3.323 1.585h-.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M22.244 253.077s.573 1.5 3.6 1.051c2.884-.429 1.462-4.611 4.06-5.747 2.857-1.249 2.238-4.517.7-5.626-1.54-1.109-5.014-1.004-7.122.653-2.109 1.656-4.534 3.084-1.238 9.67v-.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M29.316 250.984a1.333 1.333 0 01-1.372 1.294 1.332 1.332 0 11.075-2.662c.738.02 1.318.632 1.297 1.368z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#A7BBE6",
                        d: "M16.677 265.136L14.582 281.9s-1.888 1.916 7.118 5.114c7.268 2.583 12.73 1.962 13.214 1.131l-.435-18.569 6.451 4.415s-1.139-9.05-9.71-14.488c-1.56-.992-3.885-2.202-5.788-3.15-2.826-1.409-3.07-1.608-5.827-.07-.082.046-2.73 6.127-2.928 8.855v-.002zM22.789 250.957c1.551-.213 2.608-1.844 2.36-3.642-.248-1.798-1.708-3.082-3.26-2.869-1.551.213-2.608 1.843-2.36 3.641.248 1.798 1.708 3.083 3.26 2.87z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M28.007 257.674s-2.62-2.281-4.692-2.04c0 0-.024 2.745 4.692 2.04z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M16.573 261.686a1.996 1.996 0 011.029 2.626l-.358.811a2.008 2.008 0 01-2.633 1.026 1.997 1.997 0 01-1.03-2.627l.358-.81a2.008 2.008 0 012.634-1.026z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3457B8",
                        d: "M32.983 290.093l-2.749 7.948 12.57 4.323 2.748-7.948-12.569-4.323z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0A548",
                        d: "M40.432 258.138l-9.259 14.076c-1.325 2.359-5.918 3.152-8.288 1.435l-7.756-6.812 2.592-3.749 6.5 4.522s2.92-9.165 5.561-10.481c2.64-1.316 10.65 1.009 10.65 1.009z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M28.998 338.126l3.38-.574c2.23-1.126 3.259-1.943 4.298-1.404l.294.153c1.039.539.954 1.574-.185 2.296l-4.825 4.175c-1.139.724-2.726.58-3.693-.197 0 0-.582-.478-.274-2.613.175-1.218.094-1.258 1.007-1.836h-.002zM43.158 343.771l3.369.632c2.482-.285 3.732-.695 4.518.17l.223.245c.785.865.348 1.806-.973 2.09l-5.977 2.245c-1.322.285-2.758-.401-3.396-1.464 0 0-.378-.649.653-2.545.588-1.08.525-1.146 1.583-1.373z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#C6D2F2",
                        d: "M45.505 344.6c0 1.697-4.141 1.697-4.141 0v-5.518h4.14v5.518z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3457B8",
                        d: "M46.027 341.113c-.522 2.151-4.828 1.995-5.666.604-.852-6.525-3.394-16.021-.444-22.125l-1.9-35.477 10.6.137c.074 19.036-.653 38.002-2.59 56.863v-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#C6D2F2",
                        d: "M32.226 338.661c-.027 1.54-4.165 1.72-4.138.18l.089-5.004 4.137-.18-.088 5.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#3457B8",
                        d: "M32.94 336.408c-1.578 1.767-4.862 1.183-5.54-.014-1.396-7.902-2.25-16.841.012-22.668l.013-27.148 10.465 1.086-4.95 48.744z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M41.416 256.448c1.916-.567 2.657-3.76 1.653-7.133-1.004-3.372-3.371-5.646-5.288-5.078-1.917.567-2.657 3.761-1.653 7.133 1.003 3.372 3.37 5.646 5.288 5.078z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M46.363 251.822c-.364 3.025-3.304 4.571-5.436 2.977-2.132-1.594-3.566-5.338-3.202-8.364.364-3.026 2.39-4.187 4.522-2.593 2.132 1.594 4.482 4.953 4.116 7.978v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M38.077 261.304l-.323-.144c-1.09-.485-1.032-1.706-.546-2.793l2.189-6.191a2.178 2.178 0 012.865-1.094l.323.145a2.166 2.166 0 011.097 2.857l-1.765 6.272c-.487 1.087-2.75 1.433-3.84.948z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M36.455 252.812s.437 1.56 3.515 1.385c2.933-.166 1.894-4.49 4.605-5.392 2.982-.99 2.662-4.326 1.222-5.58-1.44-1.254-4.936-1.469-7.205 0-2.268 1.466-4.832 2.677-2.137 9.587z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M44.587 250.771a1.343 1.343 0 00-1.334-1.353 1.344 1.344 0 00-1.356 1.33c-.007.74.59 1.346 1.333 1.352a1.342 1.342 0 001.357-1.329z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBA63",
                        d: "M26.03 286.434c.613-6.599.506-11.417.613-18.522-.614-17.976 13.77-11.03 14.614-10.598 8.927 4.587 9.53 5.374 9.252 10.637.041 8.763.412 19.277.226 23.589-1.84 6.06-22.664-.768-24.704-5.104l-.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M16.4 250.189c-1.02 3.023-1.339 11.23.644 11.32 6.569.297 5.147-6.011 6.168-9.034 1.02-3.024.32-5.986-1.56-6.619-1.88-.63-4.234 1.309-5.254 4.333h.001zM7.472 327.772l-.976 2.793c-.075 2.155.117 3.274-.726 3.833l-.24.16c-.843.559-1.593.064-1.668-1.099l-1.16-5.387c-.075-1.163.697-2.301 1.692-2.71 0 0 .607-.239 2.1.884.852.641.917.595.976 1.526h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M44.153 258.718s-5.761-3.886-8.974-3.513c0 0 1.66 4.607 8.974 3.513z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBA63",
                        d: "M49.717 262.812s2.525 3.503 2.755 13.841l-6.279 1.733-.935-11.054 4.457-4.52h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0A548",
                        d: "M50.734 291.538l-2.11-21.947-4.038-1.011-1.596 25.19s6.708 1.436 7.744-2.233v.001z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ED5353",
                        d: "M59.367 303.367a1.574 1.574 0 00.854-2.055l-.975-2.348a1.582 1.582 0 00-2.06-.852 1.575 1.575 0 00-.854 2.056l.974 2.348a1.58 1.58 0 002.06.851z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBA63",
                        d: "M52.126 272.016l1.303 12.099 6.166 14.411-3.525 1.38-7.998-12.775a6.418 6.418 0 01-.858-2.17l-3.779-19.26 8.691 6.315z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2B4796",
                        d: "M36.628 300.095l-3.11-1.523c-.893-.276-1.587.999-1.612 1.931-.109 4.058-.388 13.403-.677 13.908-.33.58-1.675 16.442.005 22.98.641-.159 1.247-.469 1.706-.983l3.687-36.315.001.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#142B6B",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2.67",
                        d: "M319.993 179.212v13.661"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E8EEFA",
                        d: "M328.342 296.139c11.47 0 20.768-4.978 20.768-11.119s-9.298-11.119-20.768-11.119-20.768 4.978-20.768 11.119 9.298 11.119 20.768 11.119z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#142B6B",
                        d: "M330.364 255.839a2.018 2.018 0 00-2.021-2.016 2.018 2.018 0 00-2.021 2.016v28.455c0 1.114.905 2.016 2.021 2.016a2.018 2.018 0 002.021-2.016v-28.455z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0B037",
                        d: "M346.675 228.238c.144-1.08.219-2.187.219-3.315 0-5.146-1.561-9.869-4.164-13.57a19.9 19.9 0 00.554-4.67c0-9.566-6.69-17.32-14.942-17.32-8.252 0-14.942 7.754-14.942 17.32 0 1.619.196 3.184.554 4.67-2.601 3.701-4.164 8.424-4.164 13.57 0 1.128.076 2.235.219 3.315-4.56 3.882-7.378 9.201-7.378 15.073 0 11.877 11.51 21.503 25.709 21.503s25.71-9.628 25.71-21.503c0-5.872-2.818-11.191-7.379-15.073h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E0A533",
                        d: "M346.675 228.238c.144-1.08.219-2.187.219-3.315 0-5.146-1.562-9.869-4.164-13.571.359-1.487.554-3.052.554-4.669 0-7.214-3.805-13.396-9.216-16.001-5.728 35.606 10.859 51.788-14.077 72.967a30.211 30.211 0 008.351 1.167c14.199 0 25.71-9.628 25.71-21.503 0-5.872-2.818-11.192-7.379-15.073l.002-.002z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_601",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H391V354.262H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/warrantyforhouse/sharedButton/index.tsx
var sharedButton = __webpack_require__(89448);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/leaveHome/index.tsx




function LeaveHome() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-40 gap-12 lg:mt-44 mt-20 lg:mb-[100px] mb-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[558px] mx-auto lg:mx-0 order-2 lg:order-1 lg:mt-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "lg:text-lg text-base lg:leading-8 font-light",
                        children: "Don't leave your home's well-being to fate. Take the first step in preserving your home and peace of mind. Simply complete our swift and hassle-free form to request your complimentary home warranty quote. No commitments, just friendly assistance every step of the way. Your home is your sanctuary. Let WarrantyFor.House be your steadfast partner in its safety and security. Begin your journey today!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-7 text-center lg:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {
                            children: "Get Your Free Home Warranty Quote Today!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[230px] md:h-[457px] md:w-[391px] md:min-w-[354px] relative mx-auto lg:mx-0 order-1 lg:order-2 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 78739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LiesBeneath; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/icons/plumbing.tsx


function Plumbing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "77",
        height: "77",
        fill: "none",
        viewBox: "0 0 77 77",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "38.5",
                cy: "38.5",
                r: "38.5",
                fill: "#4462CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M21.877 20H20v10.394h1.877V20zM21.877 46.046H20V56.44h1.877V46.046zM56.286 46.046H54.41V56.44h1.877V46.046zM29.748 37.274h-1.015v1.892h1.015v-1.892zM22.924 54.029h30.439v-5.576h-8.919a.523.523 0 01-.523-.523v-1.786H38.37v1.786c0 .29-.234.523-.523.523H22.924v5.576zM32.672 35.355h-1.877v5.73h1.877v-5.73zM36.346 22.41H22.924v5.576h13.422c1.117 0 2.024.911 2.024 2.031v.28h5.551c0-4.78-3.611-7.886-7.575-7.886zM46.318 43.206H35.97v1.891h10.35v-1.891zM37.323 37.274h-3.6v1.892h3.6v-1.892zM46.318 31.343H35.97v1.891h10.35v-1.891zM43.921 34.28H38.37v7.883h5.551V34.28z"
            })
        ]
    });
}
/* harmony default export */ var plumbing = (Plumbing);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/icons/electricalSystems.tsx


function ElectricalSystems() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "77",
        height: "77",
        fill: "none",
        viewBox: "0 0 77 77",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "38.5",
                cy: "38.5",
                r: "38.5",
                fill: "#4462CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M44.986 18a.934.934 0 00-.233.044l-2.038.568a.932.932 0 00-.67 1.019l.16 1.223c-.37.238-.72.522-1.048.83l-1.136-.452a.932.932 0 00-1.15.408l-1.048 1.85a.932.932 0 00.233 1.193l.96.742a7.312 7.312 0 00-.16 1.325l-1.135.495a.932.932 0 00-.539 1.092l.553 2.039a.931.931 0 001.02.684l1.223-.16c.23.364.488.712.786 1.034l-.466 1.15a.932.932 0 00.407 1.15l1.835 1.048a.931.931 0 001.194-.247l.757-.99a7.16 7.16 0 001.296.16l.48 1.121a.932.932 0 001.107.539l2.038-.568a.932.932 0 00.67-1.02l-.16-1.222a7.46 7.46 0 001.063-.83l1.12.451a.932.932 0 001.166-.407l1.048-1.85a.932.932 0 00-.248-1.193l-.96-.743c.097-.437.159-.886.174-1.325l1.136-.495a.932.932 0 00.524-1.092l-.553-2.053a.932.932 0 00-1.02-.684l-1.223.175a7.13 7.13 0 00-.786-1.034l.466-1.15a.932.932 0 00-.407-1.15l-1.835-1.049a.931.931 0 00-1.194.248l-.757.975a7.14 7.14 0 00-1.296-.145l-.48-1.136a.933.933 0 00-.874-.568zm1.02 4.048a5.08 5.08 0 012.474.67c2.376 1.35 3.27 4.368 1.937 6.712-1.333 2.343-4.38 3.111-6.756 1.761-2.377-1.35-3.27-4.368-1.936-6.712.895-1.574 2.56-2.444 4.28-2.431z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M35.464 31.992a.932.932 0 00-.859.772l-.408 2.227c-.88.2-1.731.504-2.519.903l-1.776-1.456a.932.932 0 00-1.208.03l-2.475 2.241a.932.932 0 00-.131 1.238l1.31 1.849a10.66 10.66 0 00-1.121 2.373l-2.3.219a.932.932 0 00-.83.888L23 46.58a.932.932 0 00.772.96l2.27.408c.204.864.503 1.691.904 2.461l-1.456 1.733a.932.932 0 00.044 1.237l2.27 2.446a.932.932 0 001.21.131l1.892-1.296c.75.463 1.558.833 2.417 1.107l.218 2.257a.931.931 0 00.888.844l3.35.131a.932.932 0 00.96-.757l.408-2.228c.88-.2 1.718-.517 2.504-.917l1.79 1.456a.932.932 0 001.21-.029l2.474-2.242a.932.932 0 00.131-1.223l-1.31-1.864c.464-.736.847-1.53 1.121-2.373l2.286-.218a.932.932 0 00.844-.888l.146-3.305a.931.931 0 00-.772-.961l-2.271-.394a10.62 10.62 0 00-.917-2.46l1.47-1.747a.932.932 0 00-.043-1.238l-2.272-2.431a.932.932 0 00-1.208-.146l-1.893 1.31a10.913 10.913 0 00-2.417-1.12l-.233-2.243a.932.932 0 00-.888-.844l-3.349-.146a.906.906 0 00-.087 0zm1.136 5.547c.133 0 .258.009.393.015h.014c4.306.185 7.639 3.9 7.455 8.27-.184 4.368-3.823 7.794-8.125 7.614-4.305-.18-7.652-3.9-7.469-8.27.178-4.231 3.607-7.582 7.732-7.629z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ var electricalSystems = (ElectricalSystems);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/icons/heatingCooling.tsx


function HeatingCooling() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "77",
        height: "77",
        fill: "none",
        viewBox: "0 0 77 77",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "38.5",
                cy: "38.5",
                r: "38.5",
                fill: "#4462CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M27.22 38.737a1.34 1.34 0 00-1.34-1.34h-6.54a1.34 1.34 0 000 2.68h6.534c.743 0 1.347-.604 1.347-1.34zM29.111 47.878l-4.623 4.624a1.341 1.341 0 101.897 1.897l4.623-4.624a1.341 1.341 0 10-1.897-1.897zM29.111 29.59c.265.265.604.39.949.39a1.341 1.341 0 00.948-2.288l-4.623-4.623a1.341 1.341 0 10-1.897 1.897l4.623 4.623zM33.45 26.06a1.343 1.343 0 001.75.73 1.344 1.344 0 00.724-1.758l-1.32-3.19a1.353 1.353 0 00-1.758-.73 1.34 1.34 0 00-.723 1.751l1.327 3.198zM23.26 33.191l3.191 1.32a1.343 1.343 0 001.751-.73 1.334 1.334 0 00-.73-1.75l-3.19-1.32a1.332 1.332 0 00-1.751.73 1.348 1.348 0 00.73 1.75zM27.48 45.437a1.34 1.34 0 00.722-1.751 1.334 1.334 0 00-1.75-.723l-3.192 1.32a1.343 1.343 0 001.028 2.481l3.191-1.327zM35.207 50.684a1.335 1.335 0 00-1.75.723l-1.32 3.19a1.334 1.334 0 001.24 1.852c.524 0 1.028-.312 1.24-.83l1.32-3.19a1.343 1.343 0 00-.73-1.745zM56.037 38.737l2.686-2.441a1.249 1.249 0 10-1.678-1.85l-3.343 3.037h-7.556a6.022 6.022 0 00-.458-1.366l.047.04 5.24-5.24 4.518-.22a1.247 1.247 0 001.187-1.306 1.247 1.247 0 00-1.307-1.188l-3.621.172.172-3.621a1.247 1.247 0 00-1.188-1.307 1.255 1.255 0 00-1.306 1.187l-.22 4.518-4.994 4.995a6.281 6.281 0 00-1.566-1.015v-6.7l3.038-3.343a1.249 1.249 0 10-1.85-1.679l-1.194 1.314v-.465c0-.69-.558-1.247-1.247-1.247-.69 0-1.241.558-1.241 1.247v32.956c0 .69.557 1.247 1.247 1.247.69 0 1.247-.557 1.247-1.247v-.471l1.194 1.313a1.24 1.24 0 001.758.087c.511-.465.55-1.254.086-1.765l-3.038-3.343v-6.7a6.047 6.047 0 001.572-1.022l-.006.007 4.995 4.995.219 4.517c.033.67.584 1.188 1.247 1.188h.06a1.247 1.247 0 001.187-1.307l-.172-3.622 3.621.172c.684.054 1.274-.497 1.307-1.187a1.247 1.247 0 00-1.187-1.307l-4.518-.219-5.24-5.24-.047.046c.206-.43.352-.889.458-1.366h7.55l3.342 3.038a1.24 1.24 0 001.758-.086c.465-.511.425-1.3-.086-1.765l-2.673-2.44zM29.728 38.737c0 5.3 3.96 9.678 9.101 10.335v-20.67a10.405 10.405 0 00-9.1 10.335z"
            })
        ]
    });
}
/* harmony default export */ var heatingCooling = (HeatingCooling);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/icons/kitchenAppliances.tsx


function KitchenAppliances() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "77",
        height: "77",
        fill: "none",
        viewBox: "0 0 77 77",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "38.5",
                cy: "38.5",
                r: "38.5",
                fill: "#4462CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M51.306 30.812H23V59.04h28.306V30.812zm-26.8.94H49.8a.56.56 0 01.562.561V57.54a.56.56 0 01-.562.56H24.506a.56.56 0 01-.563-.56V32.313c0-.31.252-.56.563-.56zm24.732 1.122h-24.17v24.104h24.17V32.874zM33.7 40.326a.56.56 0 110-1.12h7.362a.56.56 0 110 1.12H33.7zm-5.631-5.02h18.168a.56.56 0 01.562.56v7.113c0 .31-.251.56-.562.56H28.069a.56.56 0 01-.562-.56v-7.112c0-.31.25-.56.562-.56zm17.6 1.127H28.632v5.98H45.67v-5.98zM50.794 27.674v-.276H35.346v.276c0 .57.09 1.076.231 1.431.1.245.22.4.331.4h14.324c.11 0 .23-.155.331-.4.146-.355.23-.86.23-1.431zM54.518 27.383h-2.8c-.101 0-.191.04-.257.105l-.01.006a.405.405 0 00-.105.25V27.774a.39.39 0 00.105.24l.005.01c.066.065.161.105.261.105h2.8c.101 0 .191-.04.262-.105l.005-.005a.37.37 0 00.105-.26.4.4 0 00-.1-.26l-.01-.005a.377.377 0 00-.261-.11zM33.916 28.5v-6.547H23.663V28.5c0 .275.125.525.336.71l.03.025c.23.19.547.31.888.31h7.74c.345 0 .662-.12.887-.31a.94.94 0 00.372-.735zM28.16 19.56a.56.56 0 111.119 0v.786h4.19a.56.56 0 01.562.56c0 .311-.25.567-.562.567h-9.5a.565.565 0 01-.563-.566c0-.31.251-.56.563-.56h4.19v-.786z"
            })
        ]
    });
}
/* harmony default export */ var kitchenAppliances = (KitchenAppliances);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/icons/laundryAppliances.tsx


function LaundryAppliances() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "77",
        height: "77",
        fill: "none",
        viewBox: "0 0 77 77",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "38.5",
                cy: "38.5",
                r: "38.5",
                fill: "#4462CC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M52.653 28.5v-3.98a2.52 2.52 0 00-2.52-2.52H27.52A2.524 2.524 0 0025 24.52v3.98h27.653zm-3.751-4.485c.662 0 1.234.537 1.234 1.235 0 .68-.554 1.234-1.234 1.234-.68 0-1.235-.554-1.235-1.234 0-.697.572-1.235 1.235-1.235zm-3.981 0c.662 0 1.235.537 1.235 1.235 0 .68-.555 1.234-1.235 1.234s-1.234-.554-1.234-1.234c0-.697.572-1.235 1.234-1.235zm-16.165 0h7.898a1.234 1.234 0 110 2.468h-7.898a1.234 1.234 0 110-2.468zM25.005 29.507v22.474a2.52 2.52 0 002.52 2.519h22.613a2.524 2.524 0 002.52-2.52V29.508H25.005zM38.83 49.688c-4.515 0-8.188-3.673-8.188-8.188 0-4.446 3.627-8.188 8.188-8.188 4.377 0 8.188 3.579 8.188 8.188 0 4.61-3.796 8.188-8.188 8.188z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M45.026 37.88c-.571.054-1.139.157-1.69.307-3.074.83-5.91 2.994-9.27 3.046-.816.01-1.625-.1-2.39-.242-.013.17-.027.338-.027.51 0 3.959 3.221 7.18 7.18 7.18 3.855 0 7.18-3.14 7.18-7.18a7.132 7.132 0 00-.983-3.62zm-9.692 6.606a.756.756 0 110-1.511.756.756 0 010 1.511zm3.717 1.995a.756.756 0 110-1.512.756.756 0 010 1.512zm3.117-3.905a.756.756 0 110-1.512.756.756 0 010 1.512z"
            })
        ]
    });
}
/* harmony default export */ var laundryAppliances = (LaundryAppliances);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/liesBeneath/index.tsx








const list = [
    {
        title: "Plumbing",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plumbing, {})
    },
    {
        title: "Electrical systems",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(electricalSystems, {})
    },
    {
        title: "Heating and cooling systems",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(heatingCooling, {})
    },
    {
        title: "Kitchen appliances (e.g., refrigerator, oven, dishwasher)",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(kitchenAppliances, {})
    },
    {
        title: "Laundry appliances (e.g., washer, dryer)",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(laundryAppliances, {})
    }, 
];
function LiesBeneath() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: list,
        mainTitle: "What Lies Beneath the Shield?",
        mainDescription: "Home warranties typically encompass vital systems and appliances, including:",
        colors: {
            bgColor: "#F4F9FF"
        },
        classes: {
            mainSectionClasses: "lg:pt-[67px] pt-[37px] lg:pb-[70px] pb-[35px]",
            mainTitleClasses: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-center ",
            mainDescriptionClasses: "lg:text-lg text-base lg:leading-8 font-light text-center mt-1",
            innerSectionClasses: "flex     flex-wrap  justify-center gap-[44px] lg:mt-10 mt-5  ",
            oneBoxClasses: "text-center  w-full sm:w-[193px] ",
            iconClasses: "children:mx-auto",
            titleClasses: " text-base lg:leading-8 font-bold lg:mt-[37px] mt-5"
        }
    });
}


/***/ }),

/***/ 47590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3566);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_variables_nextautowarrantyVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25224);
/* harmony import */ var _styles_variables_nextautowarrantyVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_nextautowarrantyVariables_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);









function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().field)
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-note"]),
                    fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-error-message"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["selling-point"])
                },
                colors: {
                    primaryColor: (_styles_variables_nextautowarrantyVariables_module_scss__WEBPACK_IMPORTED_MODULE_8___default().gorseYellowOrange),
                    progressBar: "#D9D9D9"
                },
                showProgress: true,
                goToThankYouPage: false,
                sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Extended Home Warranty` : "",
                sellingPointsSteps: "FIRST_STEP",
                dynamicThankYouFields: [
                    "firstName"
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 89448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27436);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `   py-4 sm:px-16 px-4 sm:text-lg font-semibold rounded-[13px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)} `,
        children: children
    });
}


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhatAreBenefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/warrantyforhouse/whatAreBenefits/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 460 458",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_208)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#ECF5FF",
                        d: "M424.191 431.057H32.523s-58.533-61.884-16.41-115.669c42.121-53.786 86.43-34.122 137.85-96.006 51.419-61.883 74.725-92.749 152.404-90.435 77.676 2.315 220.451 98.497 117.827 302.11h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E29CA1",
                        d: "M391.422 95.681s3.513-.299 5.494-2.162c1.982-1.863 5.11-2.865 5.5-3.806.343-.825-.133-2.118-2.369-1.423-2.998.932-3.457 2.524-5.619 2.402-2.162-.124-4.379.438-6.798 2.54-2.35 2.04.913 2.472 3.792 2.45z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E29CA1",
                        d: "M408.132 89.704c-5.334 1.013-12.326 2.71-14.357 2.37-1.141-.194-2.228-.269-3.288-.197a11.08 11.08 0 00-1.902.297c-4.694 4.263-1.362 7.355-1.268 7.74.831-.133 3.521-.235 4.155-.36 5.491-1.085 6.909-3.272 10.236-4.39 3.327-1.113 13.039-4.599 12.918-5.731-.086-.773-2.912-.407-6.491.271h-.006.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E8AD80",
                        d: "M397.088 93.619c-.603.238-1.207.473-1.81.695-.305.105-.606.213-.911.299-.307.088-.603.155-.913.155-.623.01-1.265-.103-1.916-.144-.647-.05-1.32-.033-1.948.152.647-.06 1.284.008 1.921.097.636.091 1.273.219 1.948.213.698-.02 1.312-.288 1.91-.543a13.11 13.11 0 001.716-.927l.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M414.404 89.632s-1.984.324-1.973.551c.011.227.063.415.365.377.302-.04 1.747-.681 1.608-.928z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F3AFB1",
                        d: "M381.657 94.264c-3.117 2.17-6.925 13.82-7.645 14.221-.72.402 5.375 5.787 6.128 6.847 0 0 3.117-14.568 8.608-15.653 5.492-1.085 6.909-3.272 10.236-4.39 3.327-1.114 13.04-4.6 12.918-5.732-.086-.772-2.912-.407-6.491.272h-.005c-5.334 1.013-12.326 2.713-14.355 2.372-1.14-.194-2.228-.268-3.288-.196-2.076.135-4.041.825-6.106 2.262v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M400.069 92.423c.925-.197 1.802-.551 2.657-.947.958-.443 1.935-.811 2.923-1.185a13.15 13.15 0 001.813-.822c-.642.105-1.328.227-2.048.363h-.006c-5.333 1.013-12.325 2.71-14.354 2.37-1.14-.195-2.228-.27-3.288-.197-2.051.133-3.992.808-6.029 2.209.161.152.329.299.512.426.606.424 1.326.62 2.062.615.972-.008 1.91-.316 2.837-.57 1.077-.297 2.148-.604 3.228-.889 2.167-.57 4.373-1.038 6.621-1.127 1.035-.041 2.053-.025 3.075-.24l-.003-.006zM411.68 89.757s-1.984.324-1.973.55c.011.228.064.416.365.377.302-.038 1.747-.68 1.608-.927z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M376.97 101.241l-34.009 43.33c-13.984-27.441-40.838-60.143-54.537-52.421-12.159 6.854 11.972 57.074 11.972 57.074s8.968 32.94 47.389 29.554c22.329-1.968 37.94-73.052 37.94-73.052l-8.752-4.488-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E69A1A",
                        d: "M381.04 114.255a67.669 67.669 0 00-5.16 15.462c-.515 2.525-.772 5.135-1.669 7.566-1.013 2.741-2.887 4.978-4.863 7.087-2.098 2.243-4.509 4.17-6.604 6.415-2.085 2.229-3.305 4.831-4.922 7.367-2.773 4.349-6.762 8.64-11.772 10.313-5.48 1.83-11.287-.709-14.384-5.493-1.384-2.137-1.459-4.419-1.556-6.883-.136-3.466-.711-6.86-1.558-10.218-1.437-5.686-3.131-11.342-3.651-17.209-.349-3.92-.266-8.075 1.032-11.835-13.158-17.372-28.235-30.348-37.414-25.174-12.159 6.855 11.971 57.075 11.971 57.075s8.969 32.939 47.39 29.554c20.671-1.822 35.579-62.856 37.682-71.923-1.752 2.481-3.221 5.152-4.52 7.896h-.002z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#8CA9D3",
                        d: "M362.057 396.82s-8.431-61.223 8.359-55.182c16.791 6.044 9.085 30.578-8.359 55.182z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M362.118 351.835c.856-.67 1.174-1.869 1.561-2.838.452-1.13.958-2.229 1.838-3.095 1.085-1.069 2.464-1.642 3.956-1.85 1.433-.196 2.961-.016 4.354-.468.055-.016.094-.055.146-.074-1.049-.726-2.195-1.382-3.559-1.872-5.412-1.946-8.193 3.109-9.492 10.836.435-.172.853-.374 1.196-.639z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M378.142 352.266c-.067 4.568-.26 9.064-1.636 13.461a52.013 52.013 0 01-2.068 5.465c-.617 1.387-1.425 2.799-2.723 3.657-2.802 1.852-6.098-.044-8.091-2.187-1.226-1.318-2.275-2.979-3.662-4.078.15 14.044 2.098 28.236 2.098 28.236 13.256-18.699 20.815-37.308 16.334-47.834-.227 1.074-.233 2.231-.25 3.28h-.002z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#8CA9D3",
                        d: "M360.947 396.227s34.334-60.392 58.021-39.625c23.686 20.766-58.021 39.625-58.021 39.625z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M383.774 366.095c.953.136 1.943.208 2.907.188.061 0 .119-.003.18-.003-.089-.022.833-.182.968-.229.958-.335 1.752-.903 2.494-1.584 1.448-1.329 2.655-2.84 4.376-3.843 3.803-2.223 8.454-2.63 12.694-3.474 1.874-.374 5.096-.518 5.868-2.633.161-.437.158-.861.075-1.276-9.724-3.544-20.524 3.452-29.786 12.807.075.014.15.039.224.05v-.003z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M418.119 372.103c-3.183 2.117-6.718 3.291-10.541 3.352-1.992.033-4.049-.138-6.011.308-1.968.445-3.391 1.506-4.711 2.987-2.464 2.763-4.756 5.196-8.241 6.655-3.631 1.52-7.622 1.78-11.517 1.669-1.583-.044-3.105-.24-4.675-.406-1.198-.128-2.782-.358-3.894.254-1.44.792-1.434 3.245-1.182 4.64.18.986.559 1.919 1.085 2.766 16.408-4.421 54.154-16.055 54.824-29.598-1.113 2.926-2.306 5.496-5.135 7.375l-.002-.002z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#9AB6E2",
                        d: "M409.261 429.496H112.856l4.252-14.82 9.997-35.101c7.084-24.778 31.696-40.284 57.116-35.955l12.833 2.226c.971.164 1.904.244 2.834.244a17.13 17.13 0 0014.249-7.652c22.022-33.039 71.811-28.947 88.164 7.248l2.186 4.858c3.856 8.572 13.923 12.403 22.501 8.563l12.796-5.73c7.487-3.361 15.827-.85 20.441 5.06a16.703 16.703 0 013.402 7.652l1.901 11.094c.487 2.752 1.539 5.182 3.037 7.206.285.365.567.728.849 1.052a17.161 17.161 0 009.959 5.67c.969.202 2.024.282 3.037.282 3.211 0 6.466-.88 9.419-2.851 6.665-4.449 15.6-3.342 21.263 2.325l8.6 8.599c11.077 11.08 3.23 30.027-12.433 30.027l.002.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M388.795 419.873c-1.829-5.634-8.757-10.975-14.883-9.615-.739.163-1.359-.222-1.608-.914-1.395-3.834.316-9.98-3.88-12.342-3.186-1.791-7.798-.711-10.643 1.268-7.396 5.147-7.219 14.731-8.597 22.729-.164.95-1.575 1.285-2.187.576-1.586-1.83-2.646-4.216-3.864-6.29-1.697-2.887-3.446-5.772-5.48-8.435-1.279-1.672-3.264-4.505-5.536-4.878-2.926-.482-2.718 4.756-2.336 6.5.941 4.299 3.363 8.07 4.481 12.298.174.653-.219 1.459-.914 1.608-1.837.402-3.446-.293-4.949-1.326-1.887-1.296-3.293-2.508-5.591-3.029-3.216-.731-8.434-.717-10.266-4.092-.65-1.198-.462-2.696-.435-4 .059-2.544.31-5.08.327-7.627.031-4.992-1.099-9.74-3.476-14.133-3.826-7.074-9.965-13.178-16.342-17.99-6.322-4.77-13.505-8.48-21.194-10.44-14.648-3.732-31.43-.321-40.755 12.312-4.08 5.523-6.48 12.123-7.523 18.878-1.218 7.89-.263 16.013.684 23.881a151.762 151.762 0 002.485 14.681h161.408c1.633-2.802 2.215-6.104 1.069-9.623l.005.003z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M261.05 326.741c4.058 2.386 8.985 2.835 13.472 3.976 3.878.985 7.468 2.58 10.543 5.168 4.694 3.954 7.399 9.582 10.535 14.726 3.761 6.174 8.934 12.248 16.095 14.426 7.891 2.403 14.631-3.255 22.207-4.377 6.062-.897 12.251-.055 17.529 3.184 5.315 3.261 9.223 8.4 12.115 13.84 2.818 5.301 5.641 10.603 11.335 13.252 7.346 3.42 15.614 2.536 22.833-.667 2.524-1.121 4.752-2.48 6.95-3.995-4.324-.974-8.957-.321-12.835 2.268a16.795 16.795 0 01-9.419 2.851c-1.013 0-2.065-.08-3.037-.285a17.129 17.129 0 01-9.959-5.67 23.092 23.092 0 01-.849-1.052c-1.498-2.023-2.55-4.454-3.037-7.206l-1.901-11.093a16.662 16.662 0 00-3.402-7.652c-4.614-5.911-12.954-8.422-20.441-5.061l-12.796 5.731c-8.578 3.839-18.645.008-22.501-8.563l-2.186-4.859c-9.469-20.955-30.143-31.126-50.149-29.584 2.219 4.2 4.747 8.197 8.896 10.639l.002.003z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D7E3F4",
                        d: "M383.099 429.496H112.856l4.252-14.82c13.358-11.985 31.817-17.856 50.6-14.617l9.998 1.699 5.383.892c1.174.202 2.348.282 3.482.282a20.25 20.25 0 007.286-1.334 20.45 20.45 0 009.715-7.774 59.407 59.407 0 0111.78-13.117 48.484 48.484 0 015.262-3.928c9.837-6.517 21.13-9.757 32.465-9.878a59.344 59.344 0 0119.552 2.915c15.343 4.859 28.942 15.913 36.512 32.715l2.632 5.75c4.656 10.326 16.757 14.9 27.04 10.285l7.772-3.483 7.49-3.361c3.402-1.539 6.964-2.024 10.363-1.7 8.825.85 16.597 7.409 18.216 16.924l.446 2.55h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#8CA9D3",
                        d: "M346.455 374.854a5.268 5.268 0 11-10.535 0 5.27 5.27 0 015.267-5.271 5.27 5.27 0 015.268 5.271z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#C3D1E2",
                        d: "M346.261 426.725s-23.76-29.966-12.913-32.032c10.848-2.068 14.463 13.433 12.913 32.032z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M332.18 398.78c1.08-.366 2.085-.69 3.228-.789 2.272-.203 4.88.26 6.759 1.611.736.531 1.221 1.185 1.697 1.893-2.134-5.002-5.564-7.746-10.516-6.802-2.278.432-3.017 2.107-2.781 4.463.551.003 1.193-.235 1.616-.376h-.003z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M341.243 416.938c-.989-.216-1.946-.653-2.851-1.199a166.907 166.907 0 007.866 10.986c.327-3.912.418-7.68.266-11.182-1.345 1.547-3.355 1.816-5.284 1.395h.003z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#8CA9D3",
                        d: "M346.261 426.725s14.98-40.298 31.507-29.966c16.53 10.332-31.507 29.966-31.507 29.966z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M357.975 407.489c1.237-1.099 1.979-2.61 3.28-3.668 1.397-1.138 3.019-1.836 4.677-2.508 1.581-.643 3.419-1.207 4.399-2.711.586-.899.852-2.344.379-3.396-5.81.902-11.144 6.846-15.337 13.349.949-.138 1.868-.415 2.602-1.066z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M366.397 413.729c-2.12.327-5.037.374-6.823 1.678-.899.659-1.478 1.658-2.405 2.306-.894.626-1.954.972-3.006 1.221-1.602.379-3.186.482-4.636.23-2.073 4.358-3.266 7.558-3.266 7.558s16.187-6.622 26.533-14.197c-2.109.579-4.323.883-6.397 1.204z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#8CA9D3",
                        d: "M346.261 426.725s-55.27-6.717-41.322-15.501c13.944-8.785 41.322 15.501 41.322 15.501z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2FAFF",
                        d: "M309.079 414.327c2.644.208 5.182-.803 7.784-1.068 3.584-.366 6.585.675 9.945 1.697 1.351.409 2.776.758 4.204.833-8.483-4.942-18.705-8.84-25.722-4.756-.064 1.589 1.949 3.148 3.789 3.294z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M330.37 423.602c-1.674-.103-3.36-.211-5.01-.546-1.719-.348-3.39-.891-5.104-1.262-1.063-.23-2.142-.324-3.222-.343 12.694 3.258 29.227 5.274 29.227 5.274s-2.572-2.268-6.502-5.153c-.141.252-.318.49-.545.709-.999.961-2.61 1.132-3.922 1.282-1.633.185-3.283.141-4.922.039z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000446",
                        d: "M437.715 429.365H20.925v.784h416.79v-.784z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M252.891 329.017a248.794 248.794 0 01-4.235 11.292c-9.173 22.854-20.989 42.045-35.764 58.044a161.758 161.758 0 01-15.055 14.385c-17.114 14.43-36.963 24.781-58.984 30.775-.828.246-1.905.426-3.059.503l-.57.034-.57-.034a14.518 14.518 0 01-3.294-.581c-21.717-5.891-41.555-16.245-58.727-30.697-11.257-9.465-21.125-20.312-29.694-32.668a183.79 183.79 0 01-9.184-14.698v-.011c-6.217-11.035-11.581-23.122-16.162-36.341C3.944 289.671-1.67 246.99.426 198.547l-.01-7.539c0-9.019 7.337-16.367 16.363-16.367h21.629c1.768-.033 48.05-1.489 89.896-49.675l6.934-7.987 6.933 7.987c41.857 48.208 88.172 49.642 90.121 49.686l21.415-.011c9.018 0 16.353 7.35 16.353 16.367l.011 8.09c2.084 47.95-3.54 90.576-17.183 129.922l.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#4462CC",
                        d: "M135.24 130.99c-44.754 51.533-94.673 52.798-96.83 52.842H16.776c-3.952 0-7.174 3.217-7.174 7.171v7.94c-2.046 47.302 3.41 88.818 16.674 127.062 11.78 33.947 28.872 60.02 52.28 79.696 16.118 13.568 34.762 23.31 55.45 28.936.36.108.775.172 1.232.202.47-.03.885-.094 1.212-.188 20.701-5.64 39.368-15.368 55.483-28.942 23.394-19.681 40.489-45.757 52.275-79.704 13.266-38.244 18.719-79.76 16.679-126.899l-.008-8.103c0-3.954-3.216-7.171-7.172-7.171h-21.584c-2.209-.044-52.134-1.309-96.885-52.842h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M197.206 263.224l-71.711 62.158-12.896-30.31-7.894-1.713 19.583 59.854c5.818 8.552 18.102 3.477 24.086-4.98l51.561-87.249-2.732 2.237.003.003z",
                        opacity: "0.35"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M195.348 258.138l-71.711 62.158-18.932-26.934-22.373 13.986 29.007 42.629c5.819 8.552 19.542 8.657 25.523.199l63.076-89.189-4.59-2.849z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#A4B7FC",
                        d: "M249.58 183.827c-11.606 82.093-82.121 145.226-167.381 145.226-20.51 0-40.138-3.646-58.323-10.329a292.442 292.442 0 01-7.626-29c-5.887-28.037-8.065-58.019-6.64-90.79v-7.92c0-3.959 3.206-7.187 7.164-7.187h21.64c2.158-.022 52.058-1.321 96.826-52.845 24.679 28.413 50.927 41.549 69.888 47.626 15.397 4.945 25.976 5.219 26.981 5.219h17.471z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#A4B7FC",
                        d: "M205.128 178.611c-22.96 66.15-85.809 113.629-159.737 113.629-9.95 0-19.69-.858-29.14-2.513-5.888-28.037-8.066-58.019-6.64-90.79v-7.92c0-3.959 3.204-7.187 7.163-7.187h21.64c2.158-.023 52.058-1.321 96.826-52.845 24.679 28.413 50.927 41.549 69.888 47.626z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1B2C4C",
                        d: "M320.89 416.351s16.536 15.661 11.194 25.373c-5.345 9.712-19.157-13.967-19.611-16.306-.454-2.339-2.566-7.73-2.566-7.73s9.893-6.6 10.925-6.207c1.03.394.058 4.87.058 4.87z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EEAB8C",
                        d: "M308.96 413.436s5.976 12.004 7.579 11.949c1.605-.053 6.001-2.988 6.001-2.988s-2.99-15.531-4.805-15.365c-1.813.169-8.777 6.404-8.777 6.404h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#175689",
                        d: "M316.118 425.614s-1.716-6.42.377-7.829c2.092-1.409 6.571 4.327 6.571 4.327s10.158 15.448 6.975 17.86c-3.183 2.408-13.923-14.358-13.923-14.358z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1B2C4C",
                        d: "M317.616 428.458s10.662 20.126 2.494 27.621c-8.169 7.494-13.688-19.358-13.37-21.722.319-2.361.042-8.145.042-8.145s11.481-3.089 12.334-2.389c.852.701-1.5 4.632-1.5 4.632v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EEAB8C",
                        d: "M307.244 421.883s1.822 13.285 3.361 13.745c1.536.462 6.64-.914 6.64-.914s2.131-15.672.36-16.093c-1.775-.421-10.361 3.259-10.361 3.259v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#175689",
                        d: "M310.134 435.711s.426-6.63 2.859-7.298c2.433-.667 4.841 6.202 4.841 6.202s4.686 17.887.9 19.152c-3.787 1.265-8.603-18.056-8.603-18.056h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2A2659",
                        d: "M308.476 187.282s41.596 75.834 46.883 106.248c5.287 30.412-33.52 122.71-33.52 122.71h-8.73l-4.633-228.958z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M319.896 389.079c2.73-7.301 3.732-14.712 3.446-22.483-.163-4.463-.298-8.934.856-13.291 1.01-3.81 2.887-7.232 4.304-10.886 3.377-8.693-1.141-17.441.158-26.325 1.148-7.844 7.813-15.044 5.585-23.275-1.5-5.54-4.506-10.57-6.405-15.971-1.633-4.643-2.776-10.186.191-14.552 2.956-4.349 9.181-6.564 14.493-5.985-14.028-32.516-34.051-69.026-34.051-69.026l4.349 214.892c3.166-3.846 5.405-8.641 7.072-13.098h.002z",
                        opacity: "0.35"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2A2659",
                        d: "M269.091 191.216c24.751-4.305 45.948-1.797 45.948-1.797l5.458 231.86s-12.707 5.124-16.97 2.951c-4.263-2.173-46.767-162.861-54.102-199.477-7.337-36.616 19.669-33.537 19.669-33.537h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M250.3 228.947a34.128 34.128 0 003.172 2.224c6.718 4.122 14.186 6.885 20.654 11.442 13.549 9.545 15.132 28.008 20.812 42.335 8.265 20.852 8.24 43.092 10.443 65.098 1.085 10.83 2.453 22.494 6.854 32.56 2.134 4.878 5.021 9.441 7.684 14.083l-4.878-207.273s-21.199-2.508-45.95 1.797c0 0-27.004-3.076-19.669 33.537.252 1.252.549 2.664.878 4.195v.002z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M289.535 86.75s11.141 5.803 17.297 17.699c6.156 11.893 34.853 102.63 13.942 118.712-6.519 5.014-21.571 22.137-61.113 7.024-41.068-15.695-15.893-107.852-7.421-122.704 8.473-14.856 18.985-23.222 37.295-20.728v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E5A25E",
                        d: "M288.206 95.454c3.887 10.338 7.526 20.758 11.053 31.215a669.918 669.918 0 019.762 31.616c3.073 10.589 5.805 21.281 7.969 32.084 1.157 5.39 1.962 10.844 2.729 16.295l.847 8.225.208 8.272c.401-11.068-1.359-22.045-3.427-32.861-2.109-10.828-4.78-21.545-7.8-32.159a671.814 671.814 0 00-9.942-31.583c-3.551-10.454-7.313-20.841-11.399-31.104z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2A530",
                        d: "M313.757 119.454s-10.208 3.262-10.714 3.287c-.507.025 3.811 15.78 7.282 17.441 3.468 1.661 6.352-.163 5.392-9.086-.961-8.923-1.96-11.642-1.96-11.642z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F2A530",
                        d: "M313.757 119.454s-2.159-.147-5.5.803c-3.341.947-5.212 2.483-5.212 2.483s7.93-.589 10.715-3.286h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D7A28E",
                        d: "M265.847 170.054c.562.016 3.136.708 8.689-.216 5.55-.925 8.198-1.814 11.88-1.196 3.681.617 11.351 4.374 10.391 4.645-.961.274-10.139.236-10.139.236s-.039 11.192-5.932 6.691c-5.893-4.502-16.156-5.028-16.156-5.028l1.27-5.132h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FBB140",
                        d: "M268.712 177.454l1.415-7.265-31.22-14.692s20.569-21.946 25.67-29.548c5.101-7.602 14.603-32.128-3.731-30.121-18.335 2.007-68.121 46.754-62.096 68.442 5.052 18.178 69.959 13.187 69.959 13.187l.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F15A29",
                        d: "M281.057 98.215c1.437-.69.268-3.267 1.702-3.962.8.338 5.016 2.824 5.816 3.164-.086 1.213-2.813 2.835-2.898 4.048 19.06 34.398 25.603 65.172 40.292 99.814-1.054 13.38-1.292 26.683-3.324 39.98-8.063-11.019-14.573-22.297-20.222-34.736-1.337-34.891-10.369-71.169-20.378-104.435-.933-.579-1.733-1.274-2.665-1.853.099-.755 1.561-1.27 1.677-2.02z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#202234",
                        d: "M285.267 88.467a29.56 29.56 0 00-5.771-.16c-.952.068-1.94.196-2.887.44.185.522.014 1.137-.72 1.35-1.359.393-2.759.654-4.08 1.155-.517.196-1.043.44-1.37.794.108.219-2.22 4.391 4.573 11.658 1.281 1.371 3.822-1.041 1.19-8.61-.606-1.738 9.123 5.997 11.063 6.299 2.887.448 5.766-4.829 2.472-8.065-1.071-1.055-2.344-4.72-3.476-5.576-1.304-.985.634.92-.994.72v-.005z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D7A28E",
                        d: "M283.761 77.955l2.381 9.18s-.817 12.66-14.012 4.122l1.852-15.265 9.777 1.96.002.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#33133F",
                        d: "M273.985 75.995l9.776 1.96 1.171 5.72c-.221.11-.443.213-.667.315-1.066.482-2.159.903-3.191 1.45-.811.43-1.611.959-2.176 1.695-.592.775-1.16-2.3-1.129-1.334.05 1.589.98 2.907 1.672 4.277.442.878.741 2.085 1.613 2.652.631.413 1.426.515 2.195.44-2.009 1.506-5.4 1.792-11.119-1.91l1.852-15.265h.003z",
                        opacity: "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D7A28E",
                        d: "M290.183 49.716s8.201 30.8-3.43 32.458c-11.63 1.658-20.626-10.136-20.626-10.136s-4.913-.387-5.708-6.21c-.639-4.692 2.342-4.069 2.342-4.069s-3.191-11.846 5.004-14.861c8.196-3.015 22.418 2.816 22.418 2.816v.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#33133F",
                        d: "M263.467 63.63s-1.943-.733-2.209.618c-.263 1.354 1.176 4.607 3.039 5.235 0 0-3.52-2.904-2.607-4.9.916-1.996 1.735-.028 1.774-.955l.003.003z",
                        opacity: "0.05"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EAAD5E",
                        d: "M282.87 95.18s-1.76 8.851-5.63 6.534c-3.869-2.317-13.12-9.56-4.733-15.972 0 0 .382 5.053 1.464 6.174 3.347 3.47 8.345-.088 8.345-.088s4.161-2.246 3.853-6.157c0 0 8.359 10.168 3.867 12.339-4.492 2.17-7.166-2.83-7.166-2.83z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#241D51",
                        d: "M270.226 39.085c12.387-.534 6.101-6.677 9.239-4.407 2.494 1.802-.395 3.928-1.693 4.731 1.768-.891 16.316-2.738 19.76 8.176 4.146 13.139-25.709 2.328-25.709 2.328 2.32 4.997-2.806 11.17-5.051 13.557.393 3.015 4.802 5.991 6.773 9.266 2.818 4.679 1.832-1.614 6.485-2.635 4.656-1.022 13.74-.759 13.585 3.499-.152 4.258-3.651 9.598-8.664 9.177-7.31-.611-18.392-3.228-20.227-18.723-5.55-5.462-6.569-24.445 5.502-24.969z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D3C971",
                        d: "M424.266 19.125h-46.767v63.808h46.767V19.125z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E59120",
                        fillRule: "evenodd",
                        d: "M377.563 21.004h21.916l24.4 24.067H396.54v3.164l27.676 32.311h-46.877l.224-59.542z",
                        clipRule: "evenodd",
                        opacity: "0.35"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M426.743 43.518h-51.724a.146.146 0 00-.146.146v2.758c0 .08.065.147.146.147h51.724a.147.147 0 00.147-.147v-2.758a.147.147 0 00-.147-.146z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF5A16",
                        d: "M428.839 45.126h-55.915v3.051h55.915v-3.05zM428.839 80.718h-55.915v3.05h55.915v-3.05z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F9F3DD",
                        d: "M399.527 50.89h-15.675v29.841h15.675v-29.84z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C8D8",
                        d: "M391.248 52.036h-6.51v8.187h6.51v-8.187zM398.574 52.039h-6.51v8.186h6.51V52.04zM391.248 61.178h-6.51v8.186h6.51v-8.186zM398.574 61.178h-6.51v8.189h6.51v-8.19z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF5A16",
                        d: "M398.483 72.304a.946.946 0 11-1.892.002.946.946 0 011.892-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M384.738 52.039l6.49 6.608V52.04h-6.49zM398.574 61.172h-4.863l4.863 4.953v-4.953zM398.574 57.709l-5.419-5.67h-1.105v7.444l.742.756h5.782v-2.53z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F9F3DD",
                        d: "M417.911 50.979h-12.99v16.48h12.99V50.98z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C8D8",
                        d: "M411.049 51.931h-5.394v6.786h5.394V51.93zM417.122 51.934h-5.394v6.785h5.394v-6.785zM411.049 59.506h-5.394v6.785h5.394v-6.785zM417.122 59.508h-5.394v6.786h5.394v-6.786z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M405.655 51.934l5.381 5.476v-5.476h-5.381zM417.122 59.503h-4.03l4.03 4.103v-4.103zM417.122 56.632l-4.492-4.698h-.916v6.168l.617.626h4.791v-2.096z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D8D1BA",
                        fillRule: "evenodd",
                        d: "M383.852 50.89V80.73h14.949l-13.98-22.383-.969-7.456z",
                        clipRule: "evenodd",
                        opacity: "0.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F9F3DD",
                        d: "M395.61 25.177h-11.481v14.567h11.481V25.177z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C8D8",
                        d: "M389.548 26.018h-4.769v6h4.769v-6zM394.915 26.018h-4.769v5.997h4.769v-5.997zM389.548 32.715h-4.769v5.997h4.769v-5.997zM394.915 32.715h-4.769v6h4.769v-6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M384.779 26.018l4.755 4.842v-4.842h-4.755zM394.915 32.71h-3.562l3.562 3.626V32.71zM394.915 30.174l-3.972-4.156h-.808v5.454l.545.554h4.235v-1.852z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F9F3DD",
                        d: "M417.632 25.177H406.15v14.567h11.482V25.177z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C8D8",
                        d: "M411.57 26.018h-4.769v6h4.769v-6zM416.937 26.018h-4.769v5.997h4.769v-5.997zM411.57 32.715h-4.769v5.997h4.769v-5.997zM416.937 32.715h-4.769v6h4.769v-6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M406.801 26.018l4.755 4.842v-4.842h-4.755zM416.937 32.71h-3.565l3.565 3.626V32.71zM416.937 30.174l-3.972-4.156h-.808v5.454l.542.554h4.238v-1.852z",
                        opacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M376.855 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M375.955 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M378.983 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M378.083 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M381.112 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M380.212 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M383.24 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M382.341 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.623-.675h-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M385.366 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M384.466 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M387.494 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M386.595 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M389.623 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M388.723 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M391.751 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M390.852 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M393.88 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M392.98 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.623-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M396.009 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M395.109 36.655H396v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M398.137 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M397.237 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M400.266 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M399.366 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M402.394 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M401.495 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M404.523 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M403.623 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M406.651 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M405.752 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M408.78 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M407.88 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.623-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M410.908 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M410.009 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M413.037 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M412.137 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.623-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M415.165 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M414.266 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M417.294 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M416.394 36.655h.891v6.899c0-.05-.265-6.224-.265-6.224l-.623-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M419.422 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M418.523 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.625-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M421.551 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M420.651 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.626-.675z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M423.679 36.655h-.899v7.286h.899v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M422.78 36.655h.891v6.899c0-.05-.266-6.224-.266-6.224l-.622-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M425.808 36.655h-.9v7.286h.9v-7.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M424.908 36.655h.892v6.899c0-.05-.266-6.224-.266-6.224l-.623-.675h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M425.982 35.53h-50.201c-.501 0-.908.291-.908.648 0 .358.407.648.908.648h50.201c.501 0 .908-.29.908-.648 0-.357-.407-.647-.908-.647zM403.172 75.363h-.958v7.741h.958v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M402.214 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M405.433 75.363h-.957v7.741h.957v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M404.476 75.363h.946v7.329c0-.053-.282-6.609-.282-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M407.692 75.363h-.958v7.741h.958v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M406.734 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M409.953 75.363h-.957v7.741h.957v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M408.996 75.363h.946v7.329c0-.053-.282-6.609-.282-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M412.212 75.363h-.955v7.741h.955v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M411.257 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M414.473 75.363h-.955v7.741h.955v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M413.518 75.363h.947v7.329c0-.053-.282-6.609-.282-6.609l-.665-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M416.732 75.363h-.955v7.741h.955v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M415.777 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M418.993 75.363h-.955v7.741h.955v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M418.038 75.363h.947v7.329c0-.053-.282-6.609-.282-6.609l-.665-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M421.257 75.363h-.957v7.741h.957v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M420.3 75.363h.946v7.329c0-.053-.282-6.609-.282-6.609l-.661-.717-.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M423.519 75.363h-.958v7.741h.958v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M422.561 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M425.777 75.363h-.957v7.741h.957v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M424.82 75.363h.946v7.329c0-.053-.282-6.609-.282-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M428.039 75.363h-.958v7.741h.958v-7.74z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#D88E2E",
                        d: "M427.081 75.363h.947v7.329c0-.053-.283-6.609-.283-6.609l-.664-.717v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M428.703 74.173h-26.708c-.265 0-.484.318-.484.714 0 .396.216.715.484.715h26.708c.266 0 .485-.319.485-.715 0-.396-.216-.714-.485-.714zM428.703 82.45h-26.708c-.265 0-.484.32-.484.715 0 .396.216.714.484.714h26.708c.266 0 .485-.318.485-.714 0-.396-.216-.714-.485-.714z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF5A16",
                        d: "M430.511 20.988l.656-.991L400.88 0l-30.284 19.997.656.99.654.995 1.503-.994h54.945l1.503.994.654-.994z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFBC4A",
                        d: "M400.88 3.02l-23.882 15.772h47.766L400.88 3.02z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0E0B0",
                        fillRule: "evenodd",
                        d: "M404.667 11.755a3.266 3.266 0 00-3.496-3.015 3.263 3.263 0 103.496 3.015zm-3.015 3.004c-.08.008-.16.01-.24.01a2.77 2.77 0 01-2.763-2.533c-.005-.08-.011-.16-.011-.24a2.77 2.77 0 012.533-2.763c.08-.006.16-.011.241-.011a2.775 2.775 0 012.762 2.533c.005.08.011.16.011.24a2.772 2.772 0 01-2.533 2.763z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#62C8D8",
                        fillRule: "evenodd",
                        d: "M401.171 12.237v2.522a2.77 2.77 0 01-2.522-2.522h2.522zM404.174 12.237a2.772 2.772 0 01-2.522 2.522v-2.522h2.522zM404.174 11.755h-2.522V9.233a2.775 2.775 0 012.522 2.522zM401.171 9.23v2.522h-2.522a2.77 2.77 0 012.522-2.522z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0E0B0",
                        fillRule: "evenodd",
                        d: "M401.652 8.74v6.511a3.436 3.436 0 01-.481 0v-6.51a3.48 3.48 0 01.481 0z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F0E0B0",
                        fillRule: "evenodd",
                        d: "M404.675 11.993c0 .08-.003.16-.008.24h-6.511a3.876 3.876 0 010-.48h6.511c.005.08.008.16.008.24z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E59120",
                        fillRule: "evenodd",
                        d: "M400.88 3.02l11.899 7.788-12.793-4.914-13.3 9.576 16.688 3.303h-26.686L400.88 3.02z",
                        clipRule: "evenodd"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_208",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H460V457.394H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

;// CONCATENATED MODULE: ./src/components/warrantyforhouse/whatAreBenefits/index.tsx



const list = [
    {
        title: "Peaceful Living: ",
        description: "Life is an unpredictable journey, and not all surprises are pleasant. With a home warranty, tranquility reigns as you're sheltered from hefty repair bills."
    },
    {
        title: "Budget Bliss: ",
        description: "Home ownership comes with costs, but a home warranty helps you manage unexpected expenses without straining your finances."
    },
    {
        title: "Ultimate Convenience: ",
        description: "No more frantic hunts for dependable contractors in emergencies. A home warranty streamlines repairs, delivering trusted professionals right to your doorstep."
    },
    {
        title: "Home Value Boost: ",
        description: "When it's time to sell, a home warranty can elevate your property's appeal. Prospective buyers appreciate a well-maintained home with the added assurance of a warranty."
    }, 
];
function WhatAreBenefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-44 gap-16 lg:mt-32 mt-16 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[520px] mx-auto lg:mx-0 order-1 lg:mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "Why Home Warranties Matter"
                    }),
                    list.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-3 first-of-type:mt-5 lg:text-lg text-base lg:leading-8 font-light",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold",
                                    children: point.title
                                }),
                                point.description
                            ]
                        }, index))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[250px] md:h-[457px] md:w-[460px] md:min-w-[460px] relative mx-auto lg:mx-0 order-2 lg:mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 64989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhatIsHomeWarranty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25811);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function WhatIsHomeWarranty() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().mainContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col lg:flex-row lg:gap-32 gap-16 lg:pt-14 pt-7 lg:pb-14 pb-7 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[737px] mx-auto lg:mx-0 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                            children: "Your Shield Against the Unexpected"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-3 lg:text-lg text-base lg:leading-8 font-light",
                            children: "Welcome to WarrantyFor.House! We understand that your home is more than just four walls; it's your haven and a significant life investment. Safeguarding it isn't just a choice; it's your duty. That's why we're here to acquaint you with the concept of home warranties—a vital guardian for your home's future."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[300px] h-[160px] md:h-[180px] md:w-[337px] md:min-w-[337px] relative mx-auto lg:mx-0 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/warrantyfor.house/assets/images/whatIsHomeWarrantyImg.png",
                        alt: "image",
                        layout: "fill"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ }),

/***/ 89588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__v8JNR"};

/***/ }),

/***/ 3566:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__Pev7r","main-banner":"styles_main-banner__KeTbD","form":"styles_form__xuEx9","step":"styles_step___cXX1","form-field":"styles_form-field__6bJWa","steps-inner":"styles_steps-inner__vsVIY","step-title":"styles_step-title__JK_Pj","label-as-step-title":"styles_label-as-step-title__Vtoss","step-description":"styles_step-description__jLA6T","fields-wrapper":"styles_fields-wrapper__BIcg1","form-button":"styles_form-button__UaYMS","radio-field":"styles_radio-field__trrjM","checkbox-field":"styles_checkbox-field__VU_fW","field-note":"styles_field-note__700U9","field-error-message":"styles_field-error-message__FvqDl","field":"styles_field__naFt8","tcpa":"styles_tcpa__PCXpQ","image":"styles_image__IrpVr","offerContainer":"styles_offerContainer__zvDFY"};

/***/ }),

/***/ 27436:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__yNIn8"};

/***/ }),

/***/ 25811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__UOi9Y"};

/***/ }),

/***/ 25224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gorseYellowOrange":"#ff9800","denimBlue":"#2f6177"};

/***/ })

}]);